/* eslint-disable */
/**
 * Product
 *
 * Direct copy of apps/rockwell-aem-commerce/components/commerce/product-new/clientlib/js/product.js
 * Only price and cart are removed from the source.
 */

import { setCenteredMaxWidth } from 'js/helpers.js';
import * as LS from '../../../../../partner-locator/locator-shared.js';
import { getBreakpointMediaQuery } from 'js/constants.js';
import { registerableComponentList } from 'js/registerable-components.js';
import { QRCode } from './qrcode.js';
import { scrollToAnchor } from 'js/ra.js';
import { openModal, handleModalClose } from '../../../../modal-container/clientlibs/site/js/modal-container.js';

const componentName = 'ra-product-new';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const defaultImage = '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg';
const ssDefaultImage = '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/ss_image_unavailable.svg';
const productImagePrefix = 'https://configurator.rockwellautomation.com/api/Doc/';
const partnerDetailPageUrl = 'https://www.rockwellautomation.com/en-us/sales/partner-details.html';
const cardRequestedFields = [
    'picture_url',
    'names_value',
    'catalogNumber',
    'productLifeCycleStatus',
];

const resultsPerPageDefault = 15;
let resultsPerPageAccessories = resultsPerPageDefault;
let resultsPerPageAlternativeProducts = resultsPerPageDefault;

let accessoriesInitialized = false;
let alternativeProductsInitialized = false;
let knowledgebaseArticlesInitialized = false;
let drawingsInitialized = false;
let qrCodeInitialized = false;

class Product {

    constructor() {

        const self = this;

        const elements = {
            contentContainer: document.querySelector(`.${componentName}__content`),
            thumbnailsButton: document.querySelectorAll(".thumbnail.thumbnail__root__product"),
            menuItems: document.querySelectorAll(`.${componentName}__sidebar-item`),
            specContent: document.querySelector(`#${componentName}-spec-table`),
            specTableTabs: document.querySelectorAll(`.${componentName}__product-table-tab`),
            noData: document.querySelector(`.${componentName}__no-data`),
            drawingsIframe: document.querySelector(`.${componentName}__drawings-iframe`),
        };

        if (elements.noData) {
            this.updateDistributorCard();
            this.addEventListeners();
            return;
        }

        Array.from(elements.menuItems).forEach((item) => {
            item.addEventListener('click', () => {
                const item1Tab = item.dataset.selector.split('_')[0];
                const item1Subtab = item.dataset.selector.split('_').length > 1 ? item.dataset.selector.split('_')[1] : null;
                const subChildContainer = document.getElementById(`${item.dataset.selector}-subcategory-items`);
                if (subChildContainer) {
                    subChildContainer.classList.toggle('ra-product-new__subcategory-items-collapse');
                }
                Array.from(elements.menuItems).forEach((otherItem) => {
                    const item2Tab = otherItem.dataset.selector.split('_')[0];
                    const item2Subtab = otherItem.dataset.selector.split('_').length > 1 ? otherItem.dataset.selector.split('_')[1] : null;
                    if ((item2Subtab && item.dataset.selector === item2Tab)) {
                        const specTable = document.querySelector(`.${componentName}__content-frame-${item1Tab} #${componentName}-spec-table`);
                        const specTableSectionContainers = specTable.querySelectorAll(`.${componentName}__product-table-section-container`);

                        specTableSectionContainers.forEach((container) => {
                            if (container.classList.contains('active')) {
                                const selectorClass = container.classList[1];

                                if (selectorClass) {
                                    const prefix = `${componentName}__product-table-section-`;
                                    const selector = selectorClass.slice(prefix.length);

                                    if (item2Subtab === selector) {
                                        otherItem.classList.add('active');
                                    }
                                }
                            }
                        });
                    }
                    else if ((otherItem !== item)
                        && (item1Subtab
                            && (otherItem.dataset.selector === item1Tab)
                            && (!otherItem.classList.contains('active')))) {
                        otherItem.classList.add('active');
                    }
                    else if (otherItem !== item) {
                        const clickedGroup = item.dataset.selector.split('_')[0];
                        const otherGroup = otherItem.dataset.selector.split('_')[0];

                        // Collapse other groups visually
                        if (clickedGroup !== otherGroup) {
                            const subChildContainer = document.getElementById(`${otherItem.dataset.selector}-subcategory-items`);
                            if (subChildContainer) {
                                subChildContainer.classList.add('ra-product-new__subcategory-items-collapse');
                            }

                            // Remove active only from parent items of other groups
                            if (!otherItem.dataset.selector.includes('_')) {
                                otherItem.classList.remove('active');
                            }
                        }

                        // Remove active from other sub-items in the same group
                        if (otherItem.dataset.selector.startsWith(clickedGroup + '_') && otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    }
                    else if (otherItem !== item && !String(item.dataset.selector).startsWith(`${otherItem.dataset.selector}_`)) {
                        const subChildContainer = document.getElementById(`${otherItem.dataset.selector}-subcategory-items`);
                        if (subChildContainer && !subChildContainer.classList.contains('ra-product-new__subcategory-items-collapse')) {
                            subChildContainer.classList.add('ra-product-new__subcategory-items-collapse');
                        }
                    }
                });
                item.classList.add('active');
                const parentSelector = `${componentName}__content-frame-${item.dataset.selector.split('_')[0]}`;
                window.location.hash = item.dataset.selector;
                if (item1Subtab) {
                    if (!document.querySelector(`.${componentName}__sidebar-item[data-selector="${item.dataset.selector}"]`)) {
                        return;
                    }
                    self.handleUpdateSpecTable(item1Subtab, item1Tab);
                }
                Array.from(elements.contentContainer.querySelectorAll(`.${componentName}__content-frame`)).forEach((frame) => {
                    if (frame.classList.contains(parentSelector)) {
                        frame.classList.add('active');
                    } else {
                        frame.classList.remove('active');
                    }
                });
                if (item.dataset.selector === 'accessories' && !accessoriesInitialized) {
                    accessoriesInitialized = true;
                    self.initAccessories();
                } else if (item.dataset.selector === 'alternative-products' && !alternativeProductsInitialized) {
                    alternativeProductsInitialized = true;
                    self.initAlternativeProducts();
                } else if (item.dataset.selector === 'technotes' && !knowledgebaseArticlesInitialized) {
                    knowledgebaseArticlesInitialized = true;
                    self.initKnowledgebaseArticles();
                } else if (item.dataset.selector === 'drawings' && !drawingsInitialized) {
                    drawingsInitialized = true;
                    self.initDrawings();
                }
            });
            item.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    item.click();
                }
            });
        });
        document.querySelector('details.ra-product-new__content-frame-accessories')?.addEventListener('toggle', (event) => {
            if (event.target.open && !accessoriesInitialized) {
                accessoriesInitialized = true;
                self.initAccessories();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-alternative-products')?.addEventListener('toggle', (event) => {
            if (event.target.open && !alternativeProductsInitialized) {
                alternativeProductsInitialized = true;
                self.initAlternativeProducts();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-technotes')?.addEventListener('toggle', (event) => {
            if (event.target.open && !knowledgebaseArticlesInitialized) {
                knowledgebaseArticlesInitialized = true;
                self.initKnowledgebaseArticles();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-drawings')?.addEventListener('toggle', (event) => {
            if (event.target.open && !drawingsInitialized) {
                drawingsInitialized = true;
                self.initDrawings();
            }
        });

        Array.from(elements.specTableTabs).forEach((tab) => {
            tab.addEventListener('click', () => {
                Array.from(elements.specTableTabs).forEach((otherTab) => {
                    if (otherTab !== tab) {
                        otherTab.classList.remove('active');
                    }
                });
                tab.classList.add('active');
                const selector = `${componentName}__product-table-section-${tab.dataset.selector}`;
                Array.from(elements.specContent.querySelectorAll(`.${componentName}__product-table-section-container`)).forEach((container) => {
                    if (container.classList.contains(selector)) {
                        container.classList.add('active');
                    } else {
                        container.classList.remove('active');
                    }
                });
            });
            tab.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    tab.click();
                }
            });
        });

        // Merge matching cells in first column
        const documentationTables = document.querySelectorAll(`.${componentName}__documentation-table`);
        Array.from(documentationTables).forEach((table) => {
            // Only process legacy documentation tables that include a first-column
            // cell with a `data-type` attribute. Skip grouped-by-type tables
            // which do not include `data-type` on the first cell to avoid
            // creating unwanted rowspans.
            if (table.classList.contains(`${componentName}__documentation-table-narrow`)) {
                return;
            }
            if (!table.querySelector('td[data-type]')) {
                return;
            }
            const rows = table.querySelectorAll('tr');
            let rowSpan = 1;
            let currentType = '';
            let currentCell = null;
            Array.from(rows).forEach((row) => {
                const cell = row.querySelector('td');
                if (!cell) {
                    return;
                }
                const type = cell.getAttribute('data-type');
                if (type === currentType) {
                    rowSpan++;
                    currentCell.rowSpan = rowSpan;
                    cell.remove();
                } else {
                    currentType = type;
                    rowSpan = 1;
                    currentCell = cell;
                }
            });
        });

        this.initSignInLinks();
        this.initSpecSignInLinks();
        this.initDesktopImageGallery();
        this.initSelects();
        this.initPagination();
        this.updateDistributorCard();
        this.checkProductImagesForErrors();

        // Check if drawings if the first tab. Init if so.
        const activeTab = document.querySelector(`.${componentName}__sidebar-item.active`);
        if (activeTab && activeTab.dataset.selector === 'drawings' && !drawingsInitialized) {
            drawingsInitialized = true;
            self.initDrawings();
        }

        const hasAfDemoData = document.querySelector(`.${componentName}__product-detail-header`)?.dataset.hasAfDemoData === 'true';
        if (hasAfDemoData) {
            self.insertDemoData();
        }

        this.addEventListeners();
    }

    readHash() {
        const hashSelectors = window.location.hash.replace('#', '').split('_');
        const group = hashSelectors[0];
        const section = hashSelectors[1];
        const subsection = hashSelectors[2];
        if (group) {
            // [LEGACY BREAKPOINT: min-width 1281px -> getBreakpointMediaQuery('up', 'large')]
            if (getBreakpointMediaQuery('up', 'large').matches) {
                const menuItemSelector = (section && section !== '-') ? `${group}_${section}` : group;
                const initialMenuItem = document.querySelector(`.${componentName}__sidebar-item[data-selector="${menuItemSelector}"]`);
                if (initialMenuItem) {
                    initialMenuItem.click();
                }
                if (section && section !== '-') {
                    initialMenuItem.closest(`.${componentName}__subcategory-items`)?.classList.remove(`${componentName}__subcategory-items-collapse`);
                }
                if (subsection) {
                    const selectElement = document.querySelector(`.${componentName}__product-table-section-select[name="${section}-section-select"][data-group="${group}"][data-breakpoint="desktop"]`);
                    const fakeOption = selectElement.closest(`.${componentName}__select-container`).querySelector(`li[data-value="${section}-${subsection}"]`);
                    if (selectElement && fakeOption) {
                        this.handleSelect(fakeOption, selectElement);
                    }
                }
            } else {
                if (subsection) {
                    const selectElement = document.querySelector(`.${componentName}__product-table-section-select[name="${section}-section-select"][data-group="${group}"][data-breakpoint="mobile"]`);
                    const fakeOption = selectElement.closest(`.${componentName}__select-container`).querySelector(`li[data-value="${section}-${subsection}"]`);
                    if (selectElement && fakeOption) {
                        this.handleSelect(fakeOption, selectElement);
                    }
                }
                if (section && section !== '-') {
                    const selectElement = document.querySelector(`.${componentName}__product-table-select[name="specTableSelectMobile"][data-category="${group}"]`);
                    const fakeOption = selectElement.closest(`.${componentName}__select-container`).querySelector(`li[data-value="${section}"]`);
                    if (selectElement && fakeOption) {
                        this.handleSelect(fakeOption, selectElement);
                    }
                }
                if (group) {
                    const groupDetails = document.querySelector(`.${componentName}__content-mobile .${componentName}__content-frame-${group}`).tagName === 'DETAILS' ? document.querySelector(`.${componentName}__content-mobile .${componentName}__content-frame-${group}`) : document.querySelector(`.${componentName}__content-mobile .${componentName}__content-frame-${group} details`);
                    if (groupDetails) {
                        groupDetails.open = true;
                    }
                }
            }
        }
    }

    initDesktopImageGallery() {
        const desktopImageContainer = document.querySelector(`.${componentName}__product-detail-header-content-image-desktop`);
        if (desktopImageContainer) {
            const desktopImageGallery = desktopImageContainer.querySelector(`.${componentName}__header-image-gallery`);
            if (desktopImageGallery) {
                const desktopImageGalleryArrows = desktopImageGallery.querySelectorAll(`.${componentName}__header-image-gallery-arrow`);
                if (desktopImageGallery.querySelector(`.${componentName}__header-image-gallery-container`).scrollHeight > desktopImageGallery.querySelector(`.${componentName}__header-image-gallery-container`).clientHeight) {
                    [...desktopImageGalleryArrows].find((arrow) => arrow.getAttribute('data-direction') === 'next').classList.add('active');
                }
            }
        }
    }

    initMultipleOriginCountriesTooltip() {
        const multipleOriginCountriesTooltipContainers = document.querySelectorAll(`.${componentName}__multiple-origin-countries-tooltip-container`);
        const multipleOriginCountriesTooltip = document.querySelector(`.${componentName}__multiple-origin-countries-tooltip`);
        multipleOriginCountriesTooltipContainers.forEach((container) => {
            const tooltipClone = multipleOriginCountriesTooltip.cloneNode(true);
            const tooltipIcon = tooltipClone.querySelector('.information-circle');
            container.appendChild(tooltipIcon);
            container.appendChild(tooltipClone);
        });
        multipleOriginCountriesTooltip?.remove();
    }

    enablePDFViewer = (pdfURL) => {
        const pdfViewerDisabled = document.getElementById('pira-pdf-viewer-disabled');
        const pdfContainer = document.querySelector('.pdf-viewer__container');

        let isExternal = true;
        try {
            if (pdfURL.includes(window.location.hostname) || pdfURL.includes('rockwellautomation.com') || pdfURL.includes('sprecherschuh.com') || pdfURL.startsWith('/content/dam/')) {
                isExternal = false;
            }
        } catch {
            // do nothing
        }

        if (pdfViewerDisabled || !pdfContainer || isExternal) {
            window.open(pdfURL, '_blank');
            return;
        }

        // replace http links with https
        pdfURL = pdfURL.replace(/^http:/, 'https:'); // eslint-disable-line no-param-reassign

        document.getElementById('cmp-pdf-viewer-container').innerHTML = `<iframe class="pdf-viewer__iframe" src="/etc.clientlibs/rockwell-aem-base/components/content/pdf-viewer/clientlibs/site/resources/viewer.html?file=${pdfURL}" ></iframe>`;
        document.body.style.overflow = 'hidden';

        // open viewer
        setTimeout(() => {
            pdfContainer.style.display = 'block';
        }, 100);

        // intercept 'local/RA' PDF links within Viewer and also open in Viewer instead of new tab
        function iFrameClick() {
            pdfContainer.querySelector('.pdf-viewer__iframe').contentWindow.document.body.onclick = (ev) => {
                ev.preventDefault();
                const originalHref = ev.target.tagName === 'A' ? ev.target.getAttribute('href') : '';
                if (originalHref && !originalHref.startsWith('#')) {
                    if (originalHref.includes('.pdf') && originalHref.includes('rockwellautomation.com')) {
                        const pdfIframe = pdfContainer.querySelector('.pdf-viewer__iframe');
                        const originalHrefHttps = originalHref.replace(/^http:/, 'https:');
                        pdfIframe.src = `/etc.clientlibs/rockwell-aem-base/components/content/pdf-viewer/clientlibs/site/resources/viewer.html?file=${originalHrefHttps}`;
                    } else {
                        window.open(originalHref, '_blank');
                    }
                }
            };
        }

        function closeLogic() {
            pdfContainer.style.display = 'none';
            document.body.style.overflow = 'auto';
            document.getElementById('cmp-pdf-viewer-container').innerHTML = '';
            pdfContainer.removeEventListener('click', closeLogic);
            window.dispatchEvent(new CustomEvent('hide-loading'));
        }

        pdfContainer.addEventListener('click', closeLogic);
        pdfContainer.querySelector('.pdf-viewer__iframe').addEventListener('load', iFrameClick);
    }

    addEventListeners() {
        // Ensure sections remain expanded on desktop
        window.addEventListener('beforeprint', (event) => {
            const bodyZoomStyle = document.createElement('style');
            bodyZoomStyle.innerHTML = `
                @media print {
                    body {
                        zoom: 65%;
                    }

                    .footer,
                    ._hj_feedback_containers {
                        display: none;
                    }
                }
            `;
            document.head.append(bodyZoomStyle);
        });
        document.addEventListener('click', (event) => {
            if (!event.target.closest(`.${componentName}__select-container`)) {
                this.hideSelect();
            }
        });

        const printButtons = document.querySelectorAll(`.${componentName}__print-button`);
        Array.from(printButtons).forEach((printButton) => {
            printButton?.addEventListener('click', () => {
                window.print();
            });
            printButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    printButton.click();
                }
            });
        });

        const emailButtons = document.querySelectorAll(`.${componentName}__email-button`);
        Array.from(emailButtons).forEach((emailButton) => {
            emailButton?.addEventListener('click', () => {
                const uri = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
                const catalogNumber = 'Catalog #: ' + document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.sku;
                const brand = 'Rockwell Automation';
                const body = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName + ' from ' + brand + '\n' + catalogNumber + '\n' + uri + '\n';
                window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName) + '&body=' + encodeURIComponent(body);
            });
            emailButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    emailButton.click();
                }
            });
        });

        const qrCodeButtons = document.querySelectorAll(`.${componentName}__qr-code-button`);
        Array.from(qrCodeButtons).forEach((qrCodeButton) => {
            qrCodeButton?.addEventListener('click', () => {
                document.querySelector(`.${componentName}__qr-code-modal`).classList.add('active');
                if (!qrCodeInitialized) {
                    const qrCodeImg = document.querySelector(`.${componentName}__qr-code-modal-img`);
                    new QRCode(qrCodeImg, {
                        text: window.location.href,
                        width: 220,
                        height: 220,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    });
                    qrCodeInitialized = true;
                }
            });
            qrCodeButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    qrCodeButton.click();
                }
            });
        });
        const qrModalCloseButtons = document.querySelectorAll(`.${componentName}__qr-code-modal-close, .${componentName}__qr-code-modal-close-button`);
        Array.from(qrModalCloseButtons).forEach((closeButton) => {
            closeButton.addEventListener('click', () => {
                document.querySelector(`.${componentName}__qr-code-modal`).classList.remove('active');
            });
            closeButton.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    closeButton.click();
                }
            });
        });

        const qrPrintButton = document.querySelector(`.${componentName}__qr-code-modal-print`);
        qrPrintButton?.addEventListener('click', () => {
            const qrModal = document.querySelector(`.${componentName}__qr-code-modal-container`);
            const qrModalStyles = document.createElement('style');
            qrModalStyles.innerHTML = `
                .${componentName}__qr-code-modal-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                    padding: 26px 40px;
                    margin: auto;
                    max-width: 100em;
                }
                .${componentName}__qr-code-modal-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 0.5rem;
                }
                .${componentName}__qr-code-modal-title {
                    color: #2D2D2D;
                    font-family: 'BarlowMedium', 'Barlow', sans-serif;
                    font-size: 24px;
                    line-height: 28px;
                }
                .${componentName}__qr-code-modal-catalog-number {
                    color: #2D2D2D;
                    font-family: 'BarlowRegular', 'Barlow', sans-serif;
                    font-size: 16px;
                    line-height: 22px;
                }
                .${componentName}__qr-code-modal-actions {
                    display: none;
                }
                .${componentName}__qr-code-modal-close {
                    display: none;
                }
                .${componentName}__qr-code-modal-close-button, .${componentName}__qr-code-modal-print {
                    display: none;
                }
            `;
            const printWindow = window.open('', '_blank');
            printWindow.document.write(qrModal.innerHTML);
            printWindow.document.head.append(qrModalStyles);
            printWindow.document.close();
            printWindow.onload = () => {
                printWindow.print();
            }
        });

        const pageLanguage = document.querySelector('meta[property="language"]') ? document.querySelector('meta[property="language"]').content.substr(0, 2) : 'en';
        const pageCountry = document.querySelector('meta[property="country"]') ? document.querySelector('meta[property="country"]').content : 'US';
        document.querySelectorAll('a').forEach((link) => {
            const originalHref = link.getAttribute('href');
            const isDownloadsReleaseNotesLink = link.classList.contains(`${componentName}__downloads-notes-link`) || link.classList.contains(`${componentName}__downloads-release-notes`);
            if (/\.pdf(\?.+)?$/.test(originalHref) && !isDownloadsReleaseNotesLink) {
                link.addEventListener('click', async (ev) => {
                    // Links on non-EN pages, pointing to Lit Lib, that are not within AB documentation resource tables
                    ev.preventDefault();
                    ev.stopPropagation();
                    const pdfLanguage = pageCountry === 'TW' ? 'zc' : pageLanguage;
                    if (pdfLanguage !== 'en' && originalHref.match(/.+literature\.rockwellautomation\.com.+/) && !(link.parentNode.getAttribute('data-label') === 'Language')) {
                        const translatedPdf = originalHref.replace(/^https?(.+-)([a-z]{2})(_[A-Z]{2})?(-.*?\.pdf.*)$/, `https$1${pdfLanguage}$4`);
                        const englishPdf = originalHref.replace(/^https?(.+-)([a-z]{2})(_[A-Z]{2})?(-.*?\.pdf.*)$/, 'https$1en$4');
                        try {
                            const response = await fetch(translatedPdf, { method: 'HEAD' });
                            if (!response.ok) {
                                throw new Error();
                            }
                            console.log('Translated PDF exists, opening it');
                            this.enablePDFViewer(translatedPdf); // If translated PDF exists, open it
                        } catch {
                            console.log('Translated PDF does not exist, opening English PDF');
                            this.enablePDFViewer(englishPdf); // Otherwise open English PDF
                        }
                    } else {
                        console.log('PDF link is not translated, opening it');
                        this.enablePDFViewer(originalHref);
                    }
                    // Click anywhere on the page to close the PDF viewer.
                });
            }
        });

        // Downloads section
        const downloadsSections = document.querySelectorAll(`.${componentName}__content-frame-downloads`);
        Array.from(downloadsSections).forEach((section) => {
            const selectTrigger = section.querySelector(`.${componentName}__downloads-select-trigger`);
            if (!selectTrigger) {
                return;
            }
            const selectActions = section.querySelector(`.${componentName}__downloads-select-actions`);
            const selectAllButton = section.querySelector(`.${componentName}__downloads-select-all-button`);
            const cancelButton = section.querySelector(`.${componentName}__downloads-select-cancel-button`);
            const downloadSelectionsButton = section.querySelector(`.${componentName}__downloads-download-selections`);
            const downloadSelectionsCount = section.querySelector(`.${componentName}__downloads-download-selections-count`);
            const downloadsTable = section.querySelector(`.${componentName}__downloads-table`);
            const downloadCheckboxes = section.querySelectorAll(`.${componentName}__downloads-table-checkbox`);
            const downloadCheckboxCells = section.querySelectorAll(`.${componentName}__downloads-table-checkbox-cell`);

            if (!selectTrigger || !selectActions) {
                return;
            }

            const updateSelectionState = () => {
                const uniqueValues = new Set(Array.from(downloadCheckboxes).filter((checkbox) => !checkbox.closest(`.${componentName}__downloads-list-item.hidden`) && !checkbox.closest(`.${componentName}__downloads-table-row.hidden`)).map((checkbox) => checkbox.value));
                const checkedValues = new Set(
                    Array.from(downloadCheckboxes)
                        .filter((checkbox) => checkbox.checked)
                        .map((checkbox) => checkbox.value)
                );
                const checkedCount = checkedValues.size;
                const totalCount = uniqueValues.size;

                if (downloadSelectionsCount) {
                    downloadSelectionsCount.textContent = `(${checkedCount})`;
                }
                if (downloadSelectionsButton) {
                    downloadSelectionsButton.disabled = checkedCount === 0;
                }
                if (selectAllButton) {
                    const allSelected = totalCount > 0 && checkedCount === totalCount;
                    const selectAllLabel = selectAllButton.querySelector('[class*="-button__text"]') || selectAllButton;
                    selectAllLabel.textContent = allSelected
                        ? selectAllButton.dataset.deselectLabel
                        : selectAllButton.dataset.selectLabel;
                }
            };

            const setSelectingMode = (isSelecting) => {
                selectActions.classList.toggle('hidden', !isSelecting);
                selectTrigger.classList.toggle('hidden', isSelecting);
                downloadsTable?.classList.toggle(`${componentName}__downloads-table--selecting`, isSelecting);
                downloadCheckboxCells.forEach((cell) => {
                    cell.classList.toggle('hidden', !isSelecting);
                });

                if (!isSelecting) {
                    downloadCheckboxes.forEach((checkbox) => {
                        checkbox.checked = false;
                    });
                }
                updateSelectionState();
            };

            const syncCheckboxGroup = (sourceCheckbox) => {
                downloadCheckboxes.forEach((checkbox) => {
                    if (checkbox !== sourceCheckbox && checkbox.value === sourceCheckbox.value) {
                        checkbox.checked = sourceCheckbox.checked;
                    }
                });
            };

            selectTrigger.addEventListener('click', () => {
                setSelectingMode(true);
            });
            selectTrigger.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    selectTrigger.click();
                }
            });

            selectAllButton?.addEventListener('click', () => {
                const uniqueValues = new Set(Array.from(downloadCheckboxes).filter((checkbox) => !checkbox.closest(`.${componentName}__downloads-list-item.hidden`) && !checkbox.closest(`.${componentName}__downloads-table-row.hidden`)).map((checkbox) => checkbox.value));
                const checkedValues = new Set(
                    Array.from(downloadCheckboxes)
                        .filter((checkbox) => checkbox.checked)
                        .map((checkbox) => checkbox.value)
                );
                const shouldSelectAll = checkedValues.size < uniqueValues.size;
                downloadCheckboxes.forEach((checkbox) => {
                    if (checkbox.closest(`.${componentName}__downloads-list-item.hidden`) || checkbox.closest(`.${componentName}__downloads-table-row.hidden`)) {
                        return;
                    }
                    checkbox.checked = shouldSelectAll;
                });
                updateSelectionState();
            });
            selectAllButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    selectAllButton.click();
                }
            });

            cancelButton?.addEventListener('click', () => {
                setSelectingMode(false);
            });
            cancelButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    cancelButton.click();
                }
            });

            downloadCheckboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    syncCheckboxGroup(checkbox);
                    updateSelectionState();
                });
            });

            downloadSelectionsButton?.addEventListener('click', () => {
                let cParam = '';
                let versionIdParam = '';
                let downloadIdParams = [];
                downloadCheckboxes.forEach((checkbox) => {
                    if (checkbox.checked) {
                        if (!checkbox.value.startsWith('---')) {
                            downloadIdParams.push(checkbox.value);
                        }
                        try {
                            const downloadLink = new URL(checkbox.closest(`.${componentName}__downloads-list-item, .${componentName}__downloads-table-row`).querySelector(`.${componentName}__downloads-download-link`).getAttribute('href'));
                            cParam = downloadLink.searchParams.get('c');
                            versionIdParam = downloadLink.searchParams.get('vid');
                        } catch {
                            return;
                        }
                    }
                });
                if (downloadIdParams.length > 0) {
                    downloadIdParams = downloadIdParams.join(',');
                }
                const downloadUrl = new URL(downloadSelectionsButton.dataset.downloadLink);
                downloadUrl.searchParams.set('c', cParam);
                downloadUrl.searchParams.set('vid', versionIdParam);
                downloadUrl.searchParams.set('dn', downloadIdParams);
                const pageLanguage = document.querySelector('meta[property="language"]') ? document.querySelector('meta[property="language"]').content.substr(0, 2) : 'en'
                if (pageLanguage.startsWith('zh')) {
                    downloadUrl.searchParams.set('lang', 'zh');
                } else if (pageLanguage === 'pt') {
                    downloadUrl.searchParams.set('lang', 'br');
                } else {
                    downloadUrl.searchParams.set('lang', pageLanguage.toLowerCase());
                }
                window.open(downloadUrl.toString(), '_blank');
            });
            downloadSelectionsButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    downloadSelectionsButton.click();
                }
            });

            updateSelectionState();
        });

        // Add tooltip functionality
        this.initMultipleOriginCountriesTooltip();
        this.initTooltips();

        this.filterSustainabilityTable();
    }

    filterSustainabilityTable = () => {
        const seriesSelect = document.querySelector('#sustainabilitySeriesSelect');
        const series = seriesSelect?.value || '';

        const tableSectionContainers = document.querySelectorAll(`.${componentName}__product-table-section-container`);
        Array.from(tableSectionContainers).forEach((container) => {
            const tableData = container.querySelectorAll(`.${componentName}__product-table-section tr, .${componentName}__product-table-section th, .${componentName}__product-table-section td`);
            Array.from(tableData).forEach((data) => {
                if (!data.dataset.series || !series || data.dataset.series === series) {
                    if (data.tagName === 'TR') {
                        Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                            cell.classList.remove('hidden');
                        });
                    }
                    data.classList.remove('hidden');
                } else {
                    if (data.tagName === 'TR') {
                        Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                            cell.classList.add('hidden');
                        });
                    }
                    data.classList.add('hidden');
                }
            });
            // For each container, check the rule for data-series rows:
            const rows = Array.from(container.querySelectorAll(`.${componentName}__product-table-section tr`));
            const rowsWithSeries = rows.filter((row) => row.dataset.series);
            if (rowsWithSeries.length > 0) {
                const rowsWithSeriesHidden = rowsWithSeries.every((row) => row.classList.contains('hidden'));
                if (rowsWithSeriesHidden) {
                    // Hide all rows without data-series
                    rows
                        .filter((row) => !row.dataset.series)
                        .forEach((row) => {
                            row.classList.add('hidden');
                            // Also hide their cells for consistency
                            Array.from(row.querySelectorAll('td, th')).forEach((cell) => {
                                cell.classList.add('hidden');
                            });
                        });
                }
            }
        });

        const indexCells = document.querySelectorAll(`.${componentName}__product-table-section .${componentName}__product-table-cell--index`);
        Array.from(indexCells).forEach((cell) => {
            if (Array.from(cell.parentElement.querySelectorAll(`th:not(.${componentName}__product-table-cell--index), td:not(.${componentName}__product-table-cell--index)`)).every((cell) => cell.classList.contains('hidden'))) {
                cell.classList.add('hidden');
            } else {
                cell.classList.remove('hidden');
            }
        });

        const tableSections = document.querySelectorAll(`.${componentName}__product-table-section`);
        Array.from(tableSections).forEach((section) => {
            if (Array.from(section.querySelectorAll(`th:not(.${componentName}__product-table-cell--index), td:not(.${componentName}__product-table-cell--index)`)).every((cell) => cell.classList.contains('hidden'))) {
                section.classList.add('hidden');
                const sectionSelectOptions = document.querySelectorAll(`.${componentName}__select li[data-value="${section.getAttribute('data-section')}"]`);
                sectionSelectOptions.forEach((option) => {
                    option.classList.add('hidden');
                    const selectOptionList = option.parentElement;
                    if (selectOptionList.querySelectorAll('li:not(.hidden)').length <= 1) {
                        selectOptionList.closest(`.${componentName}__select-container`).classList.add('hidden');
                    }
                });
            } else {
                section.classList.remove('hidden');
                const sectionSelectOptions = document.querySelectorAll(`.${componentName}__select li[data-value="${section.getAttribute('data-section')}"]`);
                sectionSelectOptions.forEach((option) => {
                    option.classList.remove('hidden');
                    const selectOptionList = option.parentElement;
                    if (selectOptionList.querySelectorAll('li:not(.hidden)').length > 1) {
                        selectOptionList.closest(`.${componentName}__select-container`).classList.remove('hidden');
                    }
                });
            }
        });

        const tableSectionHeaders = document.querySelectorAll(`.${componentName}__product-table-section-header-container`);
        Array.from(tableSectionHeaders).forEach((header) => {
            const sectionTable = header.nextElementSibling;
            if (sectionTable) {
                if (!sectionTable.classList.contains(`${componentName}__product-table-section`)) {
                    return;
                }
                if (Array.from(sectionTable.querySelectorAll(`th:not(.${componentName}__product-table-cell--index), td:not(.${componentName}__product-table-cell--index)`)).every((cell) => cell.classList.contains('hidden'))) {
                    header.classList.add('hidden');
                } else {
                    header.classList.remove('hidden');
                }
            }

            const sectionTags = header.querySelectorAll(`.${componentName}__product-table-section-header-tag`);
            Array.from(sectionTags).forEach((tag) => {
                if (tag.dataset.series !== series && tag.dataset.series !== 'All') {
                    tag.classList.add('hidden');
                } else {
                    tag.classList.remove('hidden');
                }
            });
        });

        Array.from(tableSectionContainers).forEach((container) => {
            const tabSelector = `${container.closest(`.${componentName}__product-table`).getAttribute('data-category')}_${container.getAttribute('data-class-name')}`;
            const subTab = document.querySelector(`.${componentName}__sidebar-item.${componentName}__subcategory-item[data-selector="${tabSelector}"]`);
            const mainTab = document.querySelector(`.${componentName}__sidebar-item[data-selector="${container.closest(`.${componentName}__product-table`).getAttribute('data-category')}"]`);
            const mobileSubTab = document.querySelector(`.${componentName}__select[name="specTableSelectMobile"][data-category="${container.closest(`.${componentName}__product-table`).getAttribute('data-category')}"] li[data-value="${tabSelector.replace('sustainability_', '')}"]`);
            const mobileContainer = document.querySelector(`.${componentName}__content-frame-${container.closest(`.${componentName}__product-table`).getAttribute('data-category')}`);
            if (Array.from(container.querySelectorAll(`.${componentName}__product-table-section`)).every((section) => section.classList.contains('hidden'))) {
                if (subTab) {
                    subTab.classList.add('hidden');
                    if (subTab.parentElement.querySelectorAll(`.${componentName}__sidebar-item.${componentName}__subcategory-item:not(.hidden)`).length == 0) {
                        mainTab.classList.add('hidden');
                    }
                }
                if (mobileSubTab) {
                    mobileSubTab.classList.add('hidden');
                    if (mobileSubTab.parentElement.querySelectorAll('li:not(.hidden)').length == 0) {
                        mobileContainer.classList.add('hidden');
                    }
                }
            } else {
                if (subTab) {
                    subTab.classList.remove('hidden');
                    mainTab.classList.remove('hidden');
                }
                if (mobileSubTab) {
                    mobileSubTab.classList.remove('hidden');
                    mobileContainer.classList.remove('hidden');
                }
            }
        });

        // navigate to first tab if active tab is hidden
        const activeTab = document.querySelector(`.${componentName}__sidebar-item.active`);
        const activeSubtab = document.querySelector(`.${componentName}__sidebar-item.${componentName}__subcategory-item.active`);
        if (activeSubtab && activeSubtab.classList.contains('hidden')) {
            const firstValidSubtab = activeSubtab.parentElement.querySelector(`.${componentName}__sidebar-item.${componentName}__subcategory-item:not(.hidden)`);
            activeSubtab.classList.remove('active');
            if (firstValidSubtab) {
                firstValidSubtab.click();
            } else {
                const firstValidTab = document.querySelector(`.${componentName}__sidebar-item:not(.hidden)`);
                activeTab.classList.remove('active');
                if (firstValidTab) {
                    firstValidTab.click();
                }
            }
        } else if (activeTab && activeTab.classList.contains('hidden')) {
            const firstValidTab = document.querySelector(`.${componentName}__sidebar-item:not(.hidden)`);
            activeTab.classList.remove('active');
            if (firstValidTab) {
                firstValidTab.click();
            }
        }

        // same for mobile view
        const mobileSustainabilitySubtabSelect = document.querySelector(`.${componentName}__select[name="specTableSelectMobile"][data-category="sustainability"]`);
        if (mobileSustainabilitySubtabSelect) {
            const activeMobileTab = mobileSustainabilitySubtabSelect.querySelector('li.selected');
            if (activeMobileTab && activeMobileTab.classList.contains('hidden')) {
                const firstValidMobileSubtab = mobileSustainabilitySubtabSelect.querySelector('li:not(.hidden)');
                activeMobileTab.classList.remove('selected');
                if (firstValidMobileSubtab) {
                    firstValidMobileSubtab.click();
                }
            }
        }
        const mobileTechnicalSpecsSubtabSelect = document.querySelector(`.${componentName}__select[name="specTableSelectMobile"][data-category="technical-specifications"]`);
        if (mobileTechnicalSpecsSubtabSelect) {
            const activeMobileTab = mobileTechnicalSpecsSubtabSelect.querySelector('li.selected');
            if (activeMobileTab && activeMobileTab.classList.contains('hidden')) {
                const firstValidMobileSubtab = mobileTechnicalSpecsSubtabSelect.querySelector('li:not(.hidden)');
                activeMobileTab.classList.remove('selected');
                if (firstValidMobileSubtab) {
                    firstValidMobileSubtab.click();
                }
            }
        }

        const sustainabilitySections = document.querySelectorAll(`.${componentName}__product-table-section`);
        Array.from(sustainabilitySections).forEach((section) => {
            const rows = section.querySelectorAll('tr');
            let currentIndex = -1;
            Array.from(rows).forEach((row) => {
                if (row.classList.contains('hidden')) {
                    return;
                }
                const subsectionIndex = parseInt(row.dataset.subsectionIndex);
                if (!isNaN(subsectionIndex) && subsectionIndex >= 0) {
                    row.classList.add('ra-product-new__product-table-indexed-row');
                    row.classList.add('ra-product-new__product-table-indexed-row--hide-index');

                    if (subsectionIndex > currentIndex) {
                        row.classList.add('ra-product-new__product-table-row--component-divider');
                        row.classList.remove('ra-product-new__product-table-indexed-row--hide-index');
                        row.classList.add('ra-product-new__product-table-indexed-row--padding-top-40');
                        if (currentIndex !== -1) {
                            row.classList.remove('ra-product-new__product-table-indexed-row--padding-top-40');
                            row.classList.add('ra-product-new__product-table-indexed-row--padding-top-64');
                        }
                        currentIndex = subsectionIndex;
                    }
                }
            });
        });
    }

    filterSustainabilitySections = (group, category, section, breakpoint) => {
        window.location.hash = `${group}_${category}_${section.replace(`${category}-`, '')}`;
        const categorySections = document.querySelectorAll(`.${componentName}__content-${breakpoint} .${componentName}__product-table-section-container.${componentName}__product-table-section-${category} .${componentName}__product-table-sections`);
        const seriesSelect = document.querySelector('#sustainabilitySeriesSelect');
        const series = seriesSelect?.value || '';
        Array.from(categorySections).forEach((categorySection) => {
            [...categorySection.querySelectorAll(`.${componentName}__product-table-section-header-container`)].forEach((sectionHeader) => {
                const sectionHeaderContainer = sectionHeader.parentElement;
                if (sectionHeaderContainer.classList.contains(`${componentName}__product-table-section-header-container`) || sectionHeader.dataset.filterable === 'false') {
                    return;
                }
                const sectionTable = sectionHeader.nextElementSibling;
                if (section === 'all') {
                    sectionTable.querySelectorAll('tr, th, td').forEach((data) => {
                        if (!data.dataset.series || !series || data.dataset.series === series) {
                            if (data.tagName === 'TR') {
                                Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                                    cell.classList.remove('hidden');
                                });
                            }
                            data.classList.remove('hidden');
                        } else {
                            if (data.tagName === 'TR') {
                                Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                                    cell.classList.add('hidden');
                                });
                            }
                            data.classList.add('hidden');
                        }
                    });
                    if (sectionTable && sectionTable.classList.contains(`${componentName}__product-table-section`) && !Array.from(sectionTable.querySelectorAll(`th:not(.${componentName}__product-table-cell--index), td:not(.${componentName}__product-table-cell--index)`)).every((cell) => cell.classList.contains('hidden'))) {
                        sectionHeader.classList.remove('hidden');
                    }
                    sectionHeader.classList.remove(`${componentName}__product-table-section-header--filtered`);
                } else if (sectionHeader.dataset.section === section) {
                    sectionTable.querySelectorAll('tr, th, td').forEach((data) => {
                        if (!data.dataset.series || !series || data.dataset.series === series) {
                            if (data.tagName === 'TR') {
                                Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                                    cell.classList.remove('hidden');
                                });
                            }
                            data.classList.remove('hidden');
                        } else {
                            if (data.tagName === 'TR') {
                                Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                                    cell.classList.add('hidden');
                                });
                            }
                            data.classList.add('hidden');
                        }
                    });
                    sectionHeader.classList.remove('hidden');
                    sectionHeader.classList.add(`${componentName}__product-table-section-header--filtered`);
                } else {
                    sectionTable.querySelectorAll('tr, th, td').forEach((data) => {
                        if (data.tagName === 'TR') {
                            Array.from(data.querySelectorAll('td, th')).forEach((cell) => {
                                cell.classList.add('hidden');
                            });
                        }
                        data.classList.add('hidden');
                    });
                    sectionHeader.classList.add('hidden');
                    sectionHeader.classList.remove(`${componentName}__product-table-section-header--filtered`);
                }
            });
            [...categorySection.querySelectorAll(`.${componentName}__product-table-section`)].forEach((sectionContainer) => {
                if (sectionContainer.dataset.filterable === 'false') {
                    return;
                }
                if (section === 'all') {
                    if (!Array.from(sectionContainer.querySelectorAll(`th:not(.${componentName}__product-table-cell--index), td:not(.${componentName}__product-table-cell--index)`)).every((cell) => cell.classList.contains('hidden'))) {
                        sectionContainer.classList.remove('hidden');
                    }
                } else if (sectionContainer.dataset.section === section) {
                    sectionContainer.classList.remove('hidden');
                } else {
                    sectionContainer.classList.add('hidden');
                }
            });
        });
    }

    sideScroll = (element, direction, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            if (direction == 'prev') {
                element.scrollLeft -= step;
            } else if (direction == 'next') {
                element.scrollLeft += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    verticalScroll = (element, direction, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            if (direction == 'prev') {
                element.scrollTop -= step;
            } else if (direction == 'next') {
                element.scrollTop += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    initSignInLinks = () => {
        if (localStorage.getItem('adfsLogin')) {
            const signInLinks = document.querySelectorAll(`.${componentName}__sign-in-link`);
            Array.from(signInLinks).forEach((link) => {
                link.href = localStorage.getItem('adfsLogin');
            });
        }
    }
    // Rebuild at click time: adfsLogin lands after init, and its stored state points at the wrong page.
    initSpecSignInLinks = () => {
        document.querySelectorAll(`.${componentName}__spec-login-prompt .${componentName}__sign-in-link`).forEach((link) => {
            link.addEventListener('click', () => {
                const loginUrl = localStorage.getItem('adfsLogin');
                if (loginUrl === null || loginUrl === 'undefined') return;
                try {
                    const loc = new URL(window.location.href);
                    loc.searchParams.delete('client-request-id');
                    if (loc.hash?.startsWith('#code=')) loc.hash = '';
                    const stateValue = btoa(unescape(encodeURIComponent(loc.href))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
                    link.href = loginUrl.indexOf('&state=') !== -1 ? loginUrl.replace(/&state=[^&]*/, '&state=' + stateValue) : loginUrl + '&state=' + stateValue;
                } catch (e) {
                    // Keep the current href.
                }
            });
        });
    }

    initDrawingsSignInLinks () {
        let loginUrl = localStorage.getItem("adfsLogin");
        if (loginUrl !== null && loginUrl !== 'undefined') {
            // Dynamically set state to current page URL (Safari ITP fix - survives iframe cache)
            try {
                const loc = new URL(window.location.href);
                loc.searchParams.delete('client-request-id');
                if (loc.hash?.startsWith('#code=')) loc.hash = '';
                const stateValue = btoa(unescape(encodeURIComponent(loc.href))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
                loginUrl = loginUrl.indexOf('&state=') !== -1 ? loginUrl.replace(/&state=[^&]*/, '&state=' + stateValue) : loginUrl + '&state=' + stateValue;
                document.querySelectorAll('.ra-product-new__sign-in-link').forEach((link) => {
                    link.href = loginUrl;
                });

            } catch (e) {
                // failed to set login state parameter
                console.warn("Rfailed to set login state parameter" + loginUrl);
            }
            localStorage.setItem("pageAuthAction", "login");
            const authActionPayload = { 'authAction': 'login' }
            try {
                authIframeObj?.contentWindow.postMessage(authActionPayload, '*');
                directToAuth(loginUrl);
            } catch (e) {
                // failed to post message
                console.warn("failed to post message to auth iframe" + e);
            }
        }
    }

    directToAuth(target) {
        if (
            window.location.hostname === 'localhost' &&
            !authIframeObj?.src?.startsWith(window.location.origin)
        ) {
            window.adfsAuthPopup = window.open(
                target,
                undefined,
                'toolbar=no, menubar=no, width=600, height=700, top=100, left=100'
            );
        } else {
            window.location = target;
        }
    }

    async checkProductImagesForErrors() {
        const productImages = document.querySelectorAll('.multimedia-grid img');
        Array.from(productImages).forEach((image) => {
            const isSSApp = document.querySelector(`.${componentName}--ss`) !== null;
            // Use the data-default-image attribute if available, otherwise fall back to the hardcoded defaultImage
            const imageDefaultSrc = image.dataset.defaultImage || (isSSApp ? ssDefaultImage : defaultImage);

            image.onerror = () => {
                image.src = imageDefaultSrc;
                image.classList.add(`${componentName}__default-image`);
            };
            // Check if error has already fired
            if (image.complete && !image.naturalWidth) {
                image.src = imageDefaultSrc;
                image.classList.add(`${componentName}__default-image`);
            }
        });
    }

    incrementNumberfield(input, step) {
        if ((parseInt(input.value) + step) < parseInt(input.min) || (parseInt(input.value) + step) > parseInt(input.max)) {
            return;
        }
        input.value = parseInt(input.value) + step;
    }

    handleUpdateSpecTable(selector, menu) {
        if (!selector) return;
        const scope = menu ? document.querySelector(`.ra-product-new__content-frame-${menu}`) : document;
        const specTableSectionContainers = scope.querySelectorAll(`.${componentName}__product-table-section-container`);
        specTableSectionContainers.forEach(container => container.classList.remove('active'));
        if (selector) {
            const targetContainer = scope.querySelector(`.${componentName}__product-table-section-${selector}`);
            if (targetContainer) {
                targetContainer.classList.add('active');
            }
        }
    }

     handleSelectUpdateSpecTable(selector, menu) {
        const specTableSectionContainers = document.querySelectorAll(`.${componentName}__content-mobile .${componentName}__product-table-section-container`);
        Array.from(specTableSectionContainers).forEach((container) => {
            if (container.getAttribute('data-category') === menu) {
                container.classList.remove('active');
            }
            if (container.classList.contains(`${componentName}__product-table-section-${selector}`)) {
                container.classList.add('active');
            }
        });
    }

    toCamelCase(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }

    toTitleCase(str) {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    initSelects() {
        Array.from(document.querySelectorAll(`.${componentName}__select-input`)).forEach((select) => {
            if ((select.getAttribute('name') === 'specTableSelectDesktop' || select.getAttribute('name') === 'specTableSelectMobile') && select.querySelectorAll('option').length < 1) {
                select.remove();
                return;
            }
            const selectContainer = select.closest(`.${componentName}__select-container`);

            const fakeSelect = document.createElement('div');
            fakeSelect.classList.add(`${componentName}__select`);
            fakeSelect.setAttribute('name', select.getAttribute('name'));
            fakeSelect.setAttribute('data-category', select.getAttribute('data-category'));

            const fakeSelectLabel = document.createElement('div');
            fakeSelectLabel.classList.add(`${componentName}__select-label`);
            fakeSelectLabel.setAttribute('data-category', select.getAttribute('data-category'));
            fakeSelectLabel.innerText = select.querySelector('option[selected=\'selected\']') ? select.querySelector('option[selected=\'selected\']').label : select.querySelector('option').label;
            let fakeSelectLabelWidth = 0;

            if (select.getAttribute('data-label')) {
                const fakeSelectFloatingLabel = document.createElement('div');
                fakeSelectFloatingLabel.classList.add(`${componentName}__select-floating-label`);
                fakeSelectFloatingLabel.innerText = select.getAttribute('data-label');
                fakeSelectLabel.innerText = ' ';
                selectContainer.appendChild(fakeSelectFloatingLabel);
            }
            if (select.getAttribute('data-placeholder')) {
                const fakeSelectPlaceholder = document.createElement('div');
                fakeSelectPlaceholder.classList.add(`${componentName}__select-placeholder`);
                fakeSelectPlaceholder.innerText = select.getAttribute('data-placeholder');
                fakeSelectLabel.innerText = ' ';
                selectContainer.appendChild(fakeSelectPlaceholder);
            }

            const optionList = document.createElement('ul');
            fakeSelect.appendChild(optionList);
            fakeSelectLabel.addEventListener('click', function() {
                const category = this.getAttribute('data-category');
                document.querySelectorAll('.ra-product-new__select').forEach(dropdown => {
                    if (dropdown.getAttribute('data-category') === category) {
                        dropdown.classList.toggle('active');
                    } else {
                        dropdown.classList.remove('active');
                    }
                });
                document.querySelectorAll('.ra-product-new__select-label').forEach(label => {
                    if (label.getAttribute('data-category') === category) {
                        label.classList.toggle('active');
                    } else {
                        label.classList.remove('active');
                    }
                });
                document.querySelectorAll('.ra-product-new__select-container').forEach(container => {
                    if (container.querySelector('.ra-product-new__select').getAttribute('data-category') === category) {
                        container.classList.toggle('active');
                    } else {
                        container.classList.remove('active');
                    }
                });
            });
            fakeSelectLabel.setAttribute('tabindex', '0');
            fakeSelectLabel.setAttribute('data-acsb-force-navigable', 'true');
            fakeSelectLabel.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                    event.preventDefault();
                    fakeSelectLabel.click();
                }
            });

            [...select.querySelectorAll('option')].forEach((option, index) => {
                const fakeOption = document.createElement('li');
                fakeOption.setAttribute('data-value', option.value);
                // The product-locale (PDP-unavailable) dropdown opens with nothing chosen
                // (a placeholder is shown), so don't pre-highlight the first option there.
                if (index === 0 && !select.classList.contains(`${componentName}__product-locale-select`)) {
                    fakeOption.classList.add('selected');
                }
                fakeOption.innerText = option.label;
                if (option.getAttribute('data-current') === 'true') {
                    fakeOption.setAttribute('data-current', 'true');
                }
                fakeOption.addEventListener('click', () => {
                    selectContainer.classList.add('selected');
                    selectContainer.classList.remove('active');
                    this.handleSelect(fakeOption, select);

                });
                fakeOption.setAttribute('tabindex', '0');
                fakeOption.setAttribute('data-acsb-force-navigable', 'true');
                fakeOption.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                        event.preventDefault();
                        fakeOption.click();
                    } else if (event.key === 'ArrowUp') {
                        event.preventDefault();
                        const previousOption = fakeOption.previousElementSibling;
                        if (previousOption) {
                            previousOption.focus();
                        }
                    } else if (event.key === 'ArrowDown') {
                        event.preventDefault();
                        const nextOption = fakeOption.nextElementSibling;
                        if (nextOption) {
                            nextOption.focus();
                        }
                    }
                });
                optionList.appendChild(fakeOption);
                const fakeOptionClone = fakeOption.cloneNode(true);
                fakeOptionClone.style.position = 'absolute';
                fakeOptionClone.style.visibility = 'hidden';
                fakeOptionClone.style.whiteSpace = 'nowrap';
                fakeOptionClone.style.width = 'fit-content';
                fakeOptionClone.style.fontSize = '1rem';
                document.body.appendChild(fakeOptionClone);
                if (fakeOptionClone.clientWidth > fakeSelectLabelWidth) {
                    fakeSelectLabelWidth = fakeOptionClone.clientWidth;
                    fakeSelectLabel.style.setProperty('--select-width', `${fakeSelectLabelWidth + 75}px`);
                }
                fakeOptionClone.remove();
            });

            select.insertAdjacentElement('afterEnd', fakeSelect);
            select.insertAdjacentElement('afterEnd', fakeSelectLabel);

            const initValue = select.getAttribute('data-init-value');
            if (initValue !== null) {
                select.value = initValue;
                if (select.querySelector(`option[value='${initValue}']`) !== null) {
                    select.querySelector(`option[value='${initValue}']`).selected = 'selected';
                    fakeSelectLabel.innerText = select.querySelector(`option[value='${initValue}']`).label;
                }
            }
        });
    }

    toggleSelect(selectName) {
        const fakeSelect = document.querySelector(`.${componentName}__select[name='${selectName}']`);
        if (fakeSelect.classList.contains('active')) {
            fakeSelect.classList.remove('active');
            fakeSelect.closest(`.${componentName}__select-container`).classList.remove('active');
            const fakeSelectLabel = fakeSelect.parentElement.querySelector(`.${componentName}__select-label`);
            fakeSelectLabel.classList.remove('active');
            return;
        }
        this.hideSelect();
        fakeSelect.classList.add('active');
    }

    hideSelect() {
        [...document.querySelectorAll(`.${componentName}__select`)].forEach((select) => {
            select.classList.remove('active');
        });
        [...document.querySelectorAll(`.${componentName}__select-label`)].forEach((label) => {
            label.classList.remove('active');
        });
        [...document.querySelectorAll(`.${componentName}__select-container`)].forEach((container) => {
            container.classList.remove('active');
        });
    }

    handleSelect(fakeOption, selectElement) {
        [...fakeOption.closest('ul').querySelectorAll('li')].forEach((li) => {
            li.classList.remove('selected');
        });
        fakeOption.classList.add('selected');
        const fakeSelectLabel = fakeOption.closest(`.${componentName}__select-container`).querySelector(`.${componentName}__select-label`);
        fakeSelectLabel.innerText = fakeOption.innerText.trim();

        const realOption = selectElement.querySelector(`option[value='${fakeOption.getAttribute('data-value')}']`);
        realOption.selected = 'selected';
        realOption.closest('select').value = fakeOption.getAttribute('data-value');

        if (selectElement.id === 'sustainabilitySeriesSelect') {
            this.filterSustainabilityTable();
            this.filterDownloadsTable('series');
        }
        const breakpoint = selectElement ? selectElement.getAttribute('data-breakpoint') : 'desktop';
        if (selectElement.classList.contains(`${componentName}__product-table-section-select`)) {
            this.filterSustainabilitySections(selectElement.getAttribute('data-group'), selectElement.getAttribute('data-category'), fakeOption.getAttribute('data-value'), breakpoint);
        }
        const menuCategory = selectElement ? selectElement.getAttribute('data-category') : null;
        if (selectElement.classList.contains(`${componentName}__product-table-select`)) {
            this.handleSelectUpdateSpecTable(fakeOption.getAttribute('data-value'), menuCategory, breakpoint);
        }
        if (selectElement.classList.contains(`${componentName}__downloads-version-select-input`)) {
            this.filterDownloadsTable('version');
            if (fakeOption.getAttribute('data-current') === 'true') {
                fakeSelectLabel.setAttribute('data-current', 'true');
            } else {
                fakeSelectLabel.removeAttribute('data-current');
            }
        }

        if (selectElement.classList.contains(`${componentName}__product-locale-select`)) {
            const localeString = fakeOption.innerText.trim();
            const locale = fakeOption.getAttribute('data-value');
            this.updateAlternateLocaleIframe(locale, localeString);
        }

        // Close the dropdown after selection
        this.hideSelect();
    }

    filterDownloadsTable(type) {
        const series = document.querySelector('#sustainabilitySeriesSelect')?.value || '';
        const seriesVersions = [];
        [...document.querySelectorAll(`.${componentName}__content-frame-downloads`)].forEach((downloadSection) => {
            [...downloadSection.querySelectorAll(`tbody .${componentName}__downloads-table-row, .${componentName}__downloads-list-item`)].forEach((row) => {
                if (!seriesVersions.includes(row.dataset.version) && (row.dataset.series === series || series === '')) {
                    seriesVersions.push(row.dataset.version);
                }
            });

            const downloadCheckboxes = [...downloadSection.querySelectorAll(`.${componentName}__downloads-table-checkbox`)];
            downloadCheckboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });

            if (type === 'series') {
                const downloadTab = document.querySelector(`.${componentName}__sidebar-item[data-selector='downloads']`);
                if (seriesVersions.length === 0) {
                    downloadSection.classList.add('hidden');
                    downloadTab.classList.add('hidden');
                    if (downloadTab.classList.contains('active')) {
                        document.querySelector(`.${componentName}__sidebar-item`).click();
                    }
                    return;
                } else {
                    downloadSection.classList.remove('hidden');
                    downloadTab.classList.remove('hidden');
                }

                [...downloadSection.querySelectorAll(`.${componentName}__downloads-version-select li`)].forEach((option) => {
                    if (!seriesVersions.includes(option.dataset.value)) {
                        option.classList.add('hidden');
                    } else {
                        option.classList.remove('hidden');
                    }
                });

                const firstValidOption = downloadSection.querySelector(`.${componentName}__downloads-version-select li:not(.hidden)`);
                if (firstValidOption) {
                    firstValidOption.classList.add('selected');
                    const fakeSelectLabel = firstValidOption.closest(`.${componentName}__select-container`).querySelector(`.${componentName}__select-label`);
                    fakeSelectLabel.innerText = firstValidOption.innerText.trim();
                    if (firstValidOption.getAttribute('data-current') === 'true') {
                        fakeSelectLabel.setAttribute('data-current', 'true');
                    } else {
                        fakeSelectLabel.removeAttribute('data-current');
                    }
            
                    const realOption = downloadSection.querySelector(`option[value='${firstValidOption.getAttribute('data-value')}']`);
                    realOption.selected = 'selected';
                    realOption.closest('select').value = firstValidOption.getAttribute('data-value');
                }
            }

            const version = downloadSection.querySelector(`.${componentName}__downloads-version-select-input`)?.value || downloadSection.querySelector(`.${componentName}__downloads-version-value`)?.getAttribute('data-version-name') || '';
            // The version-level "Release notes" link is only shown when the selected version has a
            // versionReleaseNoteUrl (surfaced as data-release-note-url on the version option/value).
            const releaseNotesLink = downloadSection.querySelector(`.${componentName}__downloads-release-notes`);
            if (releaseNotesLink) {
                const selectedVersionEl = downloadSection.querySelector(`.${componentName}__downloads-version-select-input option[value='${version}']`) || downloadSection.querySelector(`.${componentName}__downloads-version-value[data-version-name='${version}']`);
                const versionReleaseNoteUrl = selectedVersionEl ? selectedVersionEl.getAttribute('data-release-note-url') : '';
                if (versionReleaseNoteUrl) {
                    releaseNotesLink.href = versionReleaseNoteUrl;
                    releaseNotesLink.classList.remove('hidden');
                } else {
                    releaseNotesLink.classList.add('hidden');
                }
            }
            [...downloadSection.querySelectorAll(`tbody .${componentName}__downloads-table-row, .${componentName}__downloads-list-item`)].forEach((row) => {
                const rowSeries = row.dataset.series;
                const rowVersion = row.dataset.version;
                if ((rowSeries === series || series === '') && (rowVersion === version || version === '')) {
                    row.classList.remove('hidden');
                } else {
                    row.classList.add('hidden');
                }
            });
            [...downloadSection.querySelectorAll('thead')].forEach((head) => {
                const tableBody = head.nextElementSibling;
                const tableDivider = tableBody.nextElementSibling;
                if ([...tableBody.querySelectorAll('tr')].every((row) => row.classList.contains('hidden'))) {
                    head.classList.add('hidden');
                    if (tableDivider) {
                        tableDivider.classList.add('hidden');
                    }
                } else {
                    head.classList.remove('hidden');
                    if (tableDivider) {
                        tableDivider.classList.remove('hidden');
                    }
                    const sizeCell = head.querySelector(`.${componentName}__downloads-table-cell-size`);
                    const notesCell = head.querySelector(`.${componentName}__downloads-table-cell-notes`);
                    if (tableBody.querySelector(`.${componentName}__downloads-table-row:not(.hidden) .${componentName}__downloads-notes-link`)) {
                        sizeCell.colSpan = 1;
                        notesCell.classList.remove('hidden');
                    } else {
                        sizeCell.colSpan = 2;
                        notesCell.classList.add('hidden');
                    }
                }
            });
        });
    }

    updateAlternateLocaleIframe(locale, localeString) {
        const iframeTitle = document.querySelector(`.${componentName}__alternate-locale-iframe-title`);
        if (iframeTitle) {
            iframeTitle.textContent = `${iframeTitle.textContent} ${localeString}`;
        }
        const alternateLocaleIframe = document.querySelector(`.${componentName}__alternate-locale`);
        if (alternateLocaleIframe) {
            alternateLocaleIframe.classList.remove(`${componentName}__alternate-locale__hidden`);
        }
        const iframe = document.querySelector(`.${componentName}__alternate-locale-iframe iframe`);
        if (iframe) {
            try {
                let iframeUrlHref = window.location.href;
                const pageLocale = document.documentElement.lang.toLowerCase();
                if (iframeUrlHref.includes(pageLocale)) {
                    iframeUrlHref = iframeUrlHref.replace(pageLocale, locale);
                } else {
                    const catalogNumber = window.location.pathname.split('.')[1];
                    iframeUrlHref = `https://www.rockwellautomation.com/${locale}/products/details.${catalogNumber}.html`
                }
                if (locale === 'zh-cn') {
                    iframeUrlHref = iframeUrlHref.replace('.com/zh-cn', '.com.cn');
                }
                const iframeUrl = new URL(iframeUrlHref);
                iframeUrl.searchParams.set('previewPdpIframe', 'true');
                iframeUrl.searchParams.set('parentLocale', pageLocale);
                iframe.src = iframeUrl.toString();
            } catch (error) {
                console.warn('Error updating alternate locale iframe', error);
            }
        }
        const productUnavailableModal = document.querySelector(`.${componentName}__unavailable-modal`);
        if (productUnavailableModal) {
            productUnavailableModal.close();
        }
        handleModalClose();
    }

    async updatePdfTitles() {
        const pdfLinks = [...document.querySelectorAll('a')].filter((link) => link.href.endsWith('.pdf'));
        pdfLinks.forEach(async (link) => {
            const url = link.href;
            const response = await fetch(url);
            const responseText = await response.text();
            const metadataTitle = responseText.split('<dc:title>')[1].split('</dc:title>')[0];
            const titleXmlElement = new DOMParser().parseFromString(metadataTitle, 'text/xml');

            const title = titleXmlElement.querySelector('rdf\\:li').textContent;
            link.innerHTML = title;
        });
    }

    sortDistributors = (docs, aprCode, userLocation) => {
        const sortedDocs = docs.sort((a, b) => {
            const opCoIdxA = LS.getNearestOpCoIndex(a, aprCode, userLocation);
            const opCoIdxB = LS.getNearestOpCoIndex(b, aprCode, userLocation);
            const aCode = +LS.getField(a, LS.Fields.Distributor.LevelCode, opCoIdxA);
            const bCode = +LS.getField(b, LS.Fields.Distributor.LevelCode, opCoIdxB);
            return aCode - bCode;
        });
        return sortedDocs;
    }

    getDistributorCardContainers() {
        return [...document.querySelectorAll(`.${componentName}__distributor-card, .${componentName}__distributor-card-mobile`)].filter((container) => container.querySelector(`.${componentName}__distributor-card-partner`));
    }

    getDistributorCardElements(distributorCardContainer) {
        const root = distributorCardContainer || document;
        return {
            // Must stay qualified with `.hidden`: rendered cards are cloned from
            // this node and inserted before it, so an unqualified selector would
            // return the previously rendered card from the second card onwards.
            distributorCardPartner: root.querySelector(`.${componentName}__distributor-card-partner.hidden`),
            distributorCardSkeleton: root.querySelector(`.${componentName}__distributor-card-skeleton`),
            distributorCardContent: root.querySelector(`.${componentName}__distributor-card-content`),
            distributorCardText: root.querySelector(`.${componentName}__distributor-card-text`),
            distributorCardTextCustom: root.querySelector(`.${componentName}__distributor-card-text-custom`),
        };
    }

    async updateDistributorCard() {
        const distributorCardContainers = this.getDistributorCardContainers();
        if (!distributorCardContainers.length) {
            return;
        }
        try {
            // Wait for window.getPiraObj() to be available
            if (typeof window.getPiraObj === 'function') {
                await this.fillDistributorCard();
            } else {
                document.addEventListener('piraLoadedSynced', async () => {
                    await this.fillDistributorCard();
                });
            }
        } catch (error) {
            console.warn('Error fetching distributor data', error);
            distributorCardContainers.forEach((container) => {
                const distributorCardPartner = container.querySelector(`.${componentName}__distributor-card-partner.hidden`);
                const distributorCardContent = container.querySelector(`.${componentName}__distributor-card-content`);
                const distributorCardSkeleton = container.querySelector(`.${componentName}__distributor-card-skeleton`);
                if (distributorCardPartner) {
                    distributorCardPartner.remove();
                }
                if (distributorCardContent) {
                    distributorCardContent.classList.remove('hidden');
                }
                if (distributorCardSkeleton) {
                    distributorCardSkeleton.classList.add('hidden');
                }
            });
        }
    }

    async fillDistributorCard() {
        const altDistributorDisplay = document.querySelector(`.${componentName}__product-detail-header`).dataset.altDistributorDisplay === 'true';
        const distributorCardContainers = this.getDistributorCardContainers();
        if (!distributorCardContainers.length) {
            return;
        }

        const userLocation = await LS.readEffectiveLocation(true);
        if (!userLocation.latitude || !userLocation.longitude) {
            distributorCardContainers.forEach((container) => {
                const { distributorCardSkeleton, distributorCardContent } = this.getDistributorCardElements(container);
                if (distributorCardSkeleton) {
                    distributorCardSkeleton.classList.add('hidden');
                }
                if (distributorCardContent) {
                    distributorCardContent.classList.remove('hidden');
                }
            });
            return;
        }

        const resultsToDisplay = 4;
        const distributorDataParams = {
            facets: 'rl_partner_type_s:("Authorized Distributor")',
            geoPoint: `${userLocation.latitude},${userLocation.longitude}`,
            startIndex: 0,
            numResults: resultsToDisplay,
        }
        const distributorData = await LS.fetchData(distributorDataParams);
        const fqField = [distributorData.responseHeader?.params?.fq].flat(); // fq field can be either a string or an array, always grab it as an array
        const aprCodeField = fqField.find((str) => String(str).startsWith('rl_apr_code'));
        const aprCode = aprCodeField // extract 'TH1' from 'rl_apr_code_ss:("n/a" or "TH1")'
            ?.match(/\((.*)\)/)?.[1] // returns '"n/a" or "TH1"'
            .split('or') // returns ['"n/a" ', ' "TH1"']
            .map((value) => value.match(/"(.*)"/)?.[1]) // returns ["n/a", "TH1"]
            .filter((value) => value != null && value !== 'n/a')?.[0]; // returns "TH1"
        const state = {
            aprCode,
            docs: distributorData?.response?.docs,
        };
        const sortedDocs = this.sortDistributors(state.docs, aprCode, userLocation);
        let distributorCards = [];
        for (let i = 0; i < resultsToDisplay; i++) {
            if (!sortedDocs[i]) {
                continue;
            }
            const opCoIdx = LS.getNearestOpCoIndex(sortedDocs[i], aprCode, userLocation);
            const cardInfo = {
                doc: sortedDocs[i],
                partnerId: LS.getField(sortedDocs[i], LS.Fields.Id),
                partnerType: LS.getField(sortedDocs[i], LS.Fields.PartnerType),
                distributorName: LS.getField(sortedDocs[i], LS.FilterFacets.dist, opCoIdx),
                partnerName: LS.getField(sortedDocs[i], LS.Fields.Distributor.Name, opCoIdx),
                partnerEmail: LS.getField(sortedDocs[i], LS.Fields.Distributor.Email, opCoIdx),
                partnerPhone: LS.getField(sortedDocs[i], LS.Fields.Distributor.LocationPhone, opCoIdx),
                city: LS.getField(
                    sortedDocs[i],
                    LS.Fields.Locations.City,
                    LS.getDistributorLocationIndex(sortedDocs[i], opCoIdx),
                ),
                partnerAddress: LS.getDistributorAddressString(sortedDocs[i], opCoIdx),
            };
            distributorCards.push(cardInfo);
        }
        if (altDistributorDisplay) {
            distributorCards = distributorCards.filter(card => card.distributorName !== 'Specialty Distributor 2');
            if (distributorCards.some(card => card.distributorName === 'Value-Add')) {
                distributorCards = distributorCards.filter(card => card.distributorName === 'Value-Add');
            }
        }

        distributorCardContainers.forEach((container) => {
            const { distributorCardPartner, distributorCardSkeleton, distributorCardContent, distributorCardText, distributorCardTextCustom } = this.getDistributorCardElements(container);
            if (!distributorCardPartner || !distributorCardContent) {
                return;
            }
            if (userLocation.name) {
                distributorCardTextCustom.innerText = distributorCardTextCustom.innerText.replace('{0}', `${userLocation.name.includes(',') ? userLocation.name.split(',')[0] : userLocation.name}`);
                distributorCardTextCustom.classList.remove('hidden');
                distributorCardText.classList.add('hidden');
            } else if (distributorCards[0]?.city) {
                distributorCardTextCustom.innerText = distributorCardTextCustom.innerText.replace('{0}', `${distributorCards[0].city}`);
                distributorCardTextCustom.classList.remove('hidden');
                distributorCardText.classList.add('hidden');
            }
            distributorCardContent.classList.remove('hidden');
            if (distributorCardSkeleton) {
                distributorCardSkeleton.classList.add('hidden');
            }
        });

        for (let i = 0; (i < resultsToDisplay && i < distributorCards.length); i++) {
            const cardInfo = distributorCards[i];
            if (!cardInfo) {
                continue;
            }
            // The list query above already returns the full partner doc, so the
            // per-card `id:` lookup this used to make was a redundant round trip.
            const partnerImageSrc = await LS.getOpCoLogo({
                apiData: cardInfo.doc,
                aprCode,
                parentLocationId: LS.getField(cardInfo.doc, LS.Fields.PrimaryLocation.Id),
                parentPartnerId: LS.getField(cardInfo.doc, LS.Fields.Id)
            });
            if (cardInfo.partnerName && cardInfo.partnerId) {
                distributorCardContainers.forEach((container) => {
                    const { distributorCardPartner, distributorCardContent } = this.getDistributorCardElements(container);
                    if (!distributorCardPartner || !distributorCardContent) {
                        return;
                    }
                    const partnerDetailElement = distributorCardPartner.cloneNode(true);
                    partnerDetailElement.classList.remove('hidden');

                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).href = `${partnerDetailPageUrl}?id=${cardInfo.partnerId}&ac=${aprCode}`;

                    if (partnerImageSrc) {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).src = partnerImageSrc;
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).alt = cardInfo.partnerName;
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).addEventListener('error', () => {
                            partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon`).remove();
                            const partnerText = document.createElement('div');
                            partnerText.classList.add(`${componentName}__distributor-card-partner-text`);
                            partnerText.innerText = cardInfo.partnerName;
                            partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).insertAdjacentElement('afterBegin', partnerText);
                        });
                    } else {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon`).remove();
                        const partnerText = document.createElement('div');
                        partnerText.classList.add(`${componentName}__distributor-card-partner-text`);
                        partnerText.innerText = cardInfo.partnerName;
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).insertAdjacentElement('afterBegin', partnerText);
                    }
                    if (cardInfo.partnerEmail) {
                        const emailEl = partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`);
                        emailEl.setAttribute('data-email', cardInfo.partnerEmail);
                        emailEl.setAttribute('data-name', cardInfo.partnerName);
                        // DMX: APR-mismatch interceptor in LS.openGatedForm reads
                        // these to decide whether to surface the
                        // "is this the right distributor?" confirmation modal
                        // before submitting the gated form. Without them the
                        // PDP path bypasses APR validation entirely.
                        emailEl.setAttribute('data-apr-code', aprCode ?? '');
                        emailEl.setAttribute('data-partner-type', cardInfo.partnerType ?? '');
                        emailEl.setAttribute('data-address', cardInfo.partnerAddress ?? '');
                        LS.applyEmailOverrideToEmailElement(emailEl);
                        emailEl.addEventListener('click', LS.openGatedForm);
                        emailEl.addEventListener('keydown', (event) => {
                            if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                                LS.openGatedForm(event);
                            }
                        });
                    } else {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`).remove();
                    }
                    if (cardInfo.partnerPhone) {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).setAttribute('data-phone', cardInfo.partnerPhone);
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).setAttribute('data-title', cardInfo.partnerName);
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).addEventListener('click', () => {
                            this.openContactDialog(cardInfo, partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`));
                        });
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).addEventListener('keydown', (event) => {
                            event.preventDefault();
                            if (event.key === 'Enter' && !document.body.classList.contains('acsb-keynav')) {
                                this.openContactDialog(cardInfo, partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`));
                            }
                        });
                    } else {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).remove();
                    }
                    if (altDistributorDisplay && cardInfo.distributorName) {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-type`).innerText = cardInfo.distributorName;
                    } else {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-type`).remove();
                    }
                    distributorCardPartner.insertAdjacentElement('beforebegin', partnerDetailElement);
                    const divider = document.createElement('div');
                    divider.classList.add(`${componentName}__divider`);
                    distributorCardPartner.insertAdjacentElement('beforebegin', divider);
                });
            }
        }

        distributorCardContainers.forEach((container) => {
            const distributorCardPartner = container.querySelector(`.${componentName}__distributor-card-partner.hidden`);
            const distributorCardContent = container.querySelector(`.${componentName}__distributor-card-content`);
            const distributorCardSkeleton = container.querySelector(`.${componentName}__distributor-card-skeleton`);
            if (distributorCardPartner) {
                distributorCardPartner.remove();
            }
            if (distributorCardContent) {
                distributorCardContent.classList.remove('hidden');
            }
            if (distributorCardSkeleton) {
                distributorCardSkeleton.classList.add('hidden');
            }
        });
    }

    openContactDialog(cardInfo, targetEl) {
        const contactDialog = document.querySelector(`#${componentName}__office-contact-dialog`);
        contactDialog.querySelector('.contact-dialog__title').innerText = cardInfo.partnerName;
        contactDialog.querySelector('.contact-dialog__number').innerText = cardInfo.partnerPhone;
        contactDialog.querySelector('.contact-dialog__call-button').href = `tel:${cardInfo.partnerPhone}`;
        contactDialog.show();
        targetEl.dispatchEvent(new CustomEvent('locator__phone-clicked', { detail: targetEl.dataset, bubbles: true }));
    }

    showGridSkeleton(frameSelector) {
        const productGrids = document.querySelectorAll(`${frameSelector} .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            productGrid.innerHTML = '';
            const skeletonGridHTML = this.createSkeletonGridStructure();
            productGrid.innerHTML = skeletonGridHTML;
            productGrid.classList.add('skeleton-loading');
        });
    }

    hideGridSkeleton(frameSelector) {
        const productGrids = document.querySelectorAll(`${frameSelector} .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            productGrid.innerHTML = '';
            productGrid.classList.remove('skeleton-loading');
        });
    }

    createSkeletonGridStructure() {
        const skeletonCards = [];
        const numberOfSkeletonCards = 15;

        for (let i = 0; i < numberOfSkeletonCards; i++) {
            skeletonCards.push(`
                <div class="${componentName}__skeleton-card">
                    <div class="${componentName}__skeleton-top-section">
                        <div class="${componentName}__skeleton-image"></div>
                        <div class="${componentName}__skeleton-content">
                            <div class="${componentName}__skeleton-title"></div>
                            <div class="${componentName}__skeleton-subtitle"></div>
                            <div class="${componentName}__skeleton-price"></div>
                            <div class="${componentName}__skeleton-description">
                                <div class="${componentName}__skeleton-line"></div>
                                <div class="${componentName}__skeleton-line"></div>
                                <div class="${componentName}__skeleton-line ${componentName}__skeleton-line--short"></div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }

        return skeletonCards.join('');
    }

    async initAccessories() {
        this.showGridSkeleton(`.${componentName}__content-frame-accessories`);
        const accessories = await this.getAccessories(0, resultsPerPageAccessories);
        this.hideGridSkeleton(`.${componentName}__content-frame-accessories`);
        const productGrids = document.querySelectorAll(`.${componentName}__content-frame-accessories .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            const paginationForm = productGrid.nextElementSibling;
            let index = 0;
            const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
            accessories.list.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);

                paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(++index, resultsPerPageAccessories);
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText = accessories.totalResults;
                const totalPages = accessories.totalResults % resultsPerPageAccessories === 0 ? accessories.totalResults / resultsPerPageAccessories : Math.floor(accessories.totalResults / resultsPerPageAccessories) + 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText = totalPages;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;

                if (accessories.totalResults > resultsPerPageAccessories) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                }
            });
        });
    }

    async initAlternativeProducts() {
        this.showGridSkeleton(`.${componentName}__content-frame-alternative-products`);

        const productGrids = document.querySelectorAll(`.${componentName}__content-frame-alternative-products .${componentName}__product-grid`);
        const alternativeProductsObject = await this.getComplemetaryProducts(0, resultsPerPageAlternativeProducts);
        const alternativeProducts = alternativeProductsObject.list;
        const totalResults = alternativeProductsObject.totalResults;

        this.hideGridSkeleton(`.${componentName}__content-frame-alternative-products`);

        Array.from(productGrids).forEach((productGrid) => {
            const paginationForm = productGrid.nextElementSibling;
            let index = 0;
            const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
            alternativeProducts.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);

                paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(++index, resultsPerPageAlternativeProducts);
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText = totalResults;
                const totalPages = totalResults % resultsPerPageAlternativeProducts === 0 ? totalResults / resultsPerPageAlternativeProducts : Math.floor(totalResults / resultsPerPageAlternativeProducts) + 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText = totalPages;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
            });
            if (totalResults > resultsPerPageAlternativeProducts) {
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
            }
        });
    }

    createProductCard(productData) {
        let pageLanguage = document.querySelector('meta[property="language"]') ? document.querySelector('meta[property="language"]').content.substr(0, 2) : 'en';
        if (document.documentElement.lang === 'zh-TW') {
            pageLanguage = 'zh-tw';
        }
        // Determine the appropriate default image based on app type
        const isSSApp = document.querySelector(`.${componentName}--ss`) !== null;
        const cardDefaultImage = isSSApp ? ssDefaultImage : defaultImage;

        let productImage = productData.picture_url ? productData.picture_url : cardDefaultImage;
        if (!productImage.includes('/')) {
            productImage = productImagePrefix + productImage;
        }
        const productCard = document.createElement('div');
        productCard.classList.add(`${componentName}__product-card`);
        productCard.innerHTML = `
            <div class="${componentName}__product-card-image-container">
                <img class="${componentName}__product-card-image" src="${productImage}" alt="${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)}"/>
            </div>
            <a class="${componentName}__product-card-catalog-number" href="details.${this.encodeCatalogNumber(productData.catalogNumber)}.html">
                ${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage) ? `<span>${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)}</span>` : ''}
                <span>${productData.catalogNumber}</span>
            </a>
            <div class="${componentName}__product-card-lifecycle-status">
                <div class="${componentName}__product-card-lifecycle-status-dot ${productData.productLifeCycleStatus?.toLowerCase()}"></div>
                <div class="${componentName}__product-card-lifecycle-status-text">${productData.productLifeCycleStatus ? this.toTitleCase(productData.productLifeCycleStatus.replaceAll('_', ' ')) : ''}</div>
            </div>
            <div class="${componentName}__product-card-description">${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)?.replaceAll(',', ', ')}</div>
        `;

        const cardImage = productCard.querySelector('img');
        cardImage.onerror = () => {
            cardImage.src = cardDefaultImage;
        };
        // Check if error has already fired
        if (cardImage.complete && !cardImage.naturalWidth) {
            cardImage.src = cardDefaultImage;
        }
        return productCard;
    }

    encodeCatalogNumber = (catalogNumber) => {
        return catalogNumber.replaceAll('/', '%252F').replaceAll('.', '%252E');
    }

    async getAccessories(startIndex, numResults) {
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        let countryCode = locale.split("-")[1];
        const appType = document.querySelector(`.${componentName}__product-detail-header`).dataset.app ? document.querySelector(`.${componentName}__product-detail-header`).dataset.app.toUpperCase() : 'RA';
        const productGrid = document.querySelector(`.${componentName}__content-frame-accessories .${componentName}__product-grid`);
        const accessoriesCatalogNumberList = productGrid.dataset.accessoriesCatalognumberList;
        const accessoriesTemplateNameList = productGrid.dataset.accessoriesTemplatenameList;
        const accessories = {
            list: [],
            totalResults: 0,
        };

        let responseJson = null;
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?countryCode=${countryCode}&app=${appType}&getAccessories=true&startIndex=${startIndex}&numResults=${numResults}&accessoriesCatalogNumbers=${accessoriesCatalogNumberList}&accessoriesTemplateIDs=${accessoriesTemplateNameList}`);
            responseJson = await response.json();
            accessories.list = responseJson.dataList;
            accessories.totalResults = responseJson.totalNumber;
        } catch (error) {
            console.warn('Error fetching product accessories:', error);
        }
        return accessories;
    }

    async getComplemetaryProducts(startIndex, numResults) {
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        let countryCode = locale.split("-")[1];
        const productGrid = document.querySelector(`.${componentName}__content-frame-alternative-products .${componentName}__product-grid`);
        const categoryUrlList = productGrid.dataset.categoryList.split(', ').filter((url) => url !== '');
        const appType = document.querySelector(`.${componentName}__product-detail-header`).dataset.app ? document.querySelector(`.${componentName}__product-detail-header`).dataset.app.toUpperCase() : 'RA';
        let alternativeProducts = {
            list: [],
            totalResults: 0,
        };

        let responseJson = null;
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?countryCode=${countryCode}&app=${appType}&categoryIds=${categoryUrlList.join(',')}&fields=${cardRequestedFields.join(',')}&startIndex=${startIndex}&numResults=${numResults}`);
            responseJson = await response.json();
            alternativeProducts.list = responseJson.docs;
            alternativeProducts.totalResults = responseJson.total;
        } catch (error) {
            console.warn('Error fetching alternative products:', error);
        }
        return alternativeProducts;
    }

    async getKnowledgebaseArticles() {
        let responseJson = null;
        let knowledgebaseArticles = [];
        const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?catalogNumber=${catalogNumber}&getKnoweledgebaseArticles=true`);
            responseJson = await response.json();
            for (let i = 0; i < Math.min(responseJson.total, 10); i++) {
                knowledgebaseArticles.push({
                    title: responseJson.docs[i].title,
                    url: responseJson.docs[i].url,
                });
            }
        } catch (error) {
            console.warn('Error fetching knowledgebase articles:', error);
        }
        return knowledgebaseArticles;
    }

    async initKnowledgebaseArticles() {
        window.dispatchEvent(new CustomEvent('show-loading'));
        const knowledgebaseArticles = await this.getKnowledgebaseArticles();
        window.dispatchEvent(new CustomEvent('hide-loading'));

        const knowledgebaseArticleTables = document.querySelectorAll(`.${componentName}__technotes-table`);
        Array.from(knowledgebaseArticleTables).forEach((table) => {
            knowledgebaseArticles.forEach((article) => {
                const row = document.createElement('tr');
                row.classList.add(`${componentName}__technotes-row`);

                const technotesCell = document.createElement('td');
                technotesCell.classList.add(`${componentName}__technotes-cell`);
                const technotesLink = document.createElement('a');
                technotesLink.href = article.url;
                technotesLink.innerText = article.title;
                technotesCell.append(technotesLink);

                row.append(technotesCell);
                // Ensure rows are added inside a tbody. Create tbody if it doesn't exist.
                let tbody = table.querySelector('tbody');
                if (!tbody) {
                    tbody = document.createElement('tbody');
                    table.appendChild(tbody);
                }
                tbody.appendChild(row);
            });
        });
    }

    initDrawings() {
        this.initDrawingsSignInLinks();
        const iframe = document.querySelector(`.${componentName}__drawings-iframe`);
        if (iframe) {
            iframe.setAttribute('src', iframe.dataset.src);
        }
    }

    initPagination() {
        const paginationForms = document.querySelectorAll(`.${componentName}__product-grid-pagination-form`);

        Array.from(paginationForms).forEach((paginationForm) => {
            const productGrid = paginationForm.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid`);
            const paginationInput = paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`);
            paginationForm.addEventListener('submit', (event) => {
                event.preventDefault();
                if (!paginationInput.validity.valid) return;
                const currentPage = parseInt(paginationInput.value);
                const totalPages = +paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText.trim();
                const totalResults = +paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText.trim();
                if (currentPage <= 1) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = true;
                } else {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = false;
                }
                if (currentPage >= totalPages) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                } else {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                }
                let type = '';
                if (paginationForm.closest(`.${componentName}__content-frame-accessories`)) {
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = (currentPage - 1) * resultsPerPageAccessories + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(currentPage * resultsPerPageAccessories, totalResults);
                    type = 'accessories';
                } else if (paginationForm.closest(`.${componentName}__content-frame-alternative-products`)) {
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = (currentPage - 1) * resultsPerPageAlternativeProducts + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(currentPage * resultsPerPageAlternativeProducts, totalResults);
                    type = 'alternative-products';
                }
                this.updateProductGridPage(productGrid, currentPage, type);
                paginationInput.defaultValue = String(currentPage);
            });
            paginationInput.addEventListener('input', (event) => {
                const input = event.target;
                const inputError = input.parentElement?.querySelector(`.${componentName}__product-grid-pagination-error`);

                if (!inputError) return;

                if (!inputError.classList.contains('is-visible')) {
                    return;
                }

                if (input.validity.valid) {
                    inputError.classList.remove('is-visible');
                    inputError.style.removeProperty('--pagination-error-max-width');
                } else {
                    input.checkValidity();
                }
            });
            paginationInput.addEventListener('invalid', (event) => {
                event.preventDefault();
                const input = event.target;
                const inputError = input.parentElement?.querySelector(`.${componentName}__product-grid-pagination-error`);
                const errorText = inputError?.querySelector(`.${componentName}__product-grid-pagination-error-text`);

                if (!inputError || !errorText) return;

                inputError.classList.add('is-visible');
                const validity = input.validity;

                if (validity.rangeUnderflow) {
                    errorText.textContent = `${input.dataset.errorMin}  ${input.min}`;
                } else if (validity.rangeOverflow) {
                    errorText.textContent = `${input.dataset.errorMax}  ${input.max}`;
                } else if (validity.badInput || validity.typeMismatch) {
                    errorText.textContent = input.dataset.errorNumber;
                } else {
                    errorText.textContent = input.validationMessage;
                }

                setCenteredMaxWidth(input, inputError, '--pagination-error-max-width');

                if (!input.restorePaginationHandler) {
                    input.restorePaginationHandler = (e) => {
                        if (!input.contains(e.target)) {
                            if (inputError.classList.contains('is-visible')) {
                                input.value = input.defaultValue;
                                inputError.classList.remove('is-visible');
                                inputError.style.removeProperty('--pagination-error-max-width');
                            }
                            document.removeEventListener('pointerdown', input.restorePaginationHandler);
                            input.restorePaginationHandler = null;
                        }
                    };
                    setTimeout(() => document.addEventListener('pointerdown', input.restorePaginationHandler), 0);
                }
            });
            paginationInput.addEventListener('blur', (event) => {
                const input = event.target;
                if (!input.validity.valid) {
                    input.checkValidity();
                } else if (input.value !== input.defaultValue) {
                    paginationForm.requestSubmit();
                }
            });
            const paginationButtons = paginationForm.querySelectorAll(`.${componentName}__product-grid-pagination-button`);
            Array.from(paginationButtons).forEach((button) => {
                button.addEventListener('click', (event) => {
                    const currentPage = parseInt(paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value);
                    const totalPages = +paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText.trim();
                    if (button.name === 'prev' && currentPage > 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value--;
                    } else if (button.name === 'next' && currentPage < totalPages) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value++;
                    }
                });
            });
        });
        const numResultsInputs = document.querySelectorAll(`.${componentName}__product-grid-items-per-page select`);
        Array.from(numResultsInputs).forEach((numResultsInput) => {
            const productGrid = numResultsInput.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid`);
            const paginationForm = numResultsInput.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid-pagination-form`);
            numResultsInput.addEventListener('change', (event) => {
                const totalResults = +paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText.trim();
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = true;
                let type = '';
                if (numResultsInput.closest(`.${componentName}__content-frame-accessories`)) {
                    resultsPerPageAccessories = parseInt(event.target.value);
                    const totalPages = totalResults % resultsPerPageAccessories === 0 ? totalResults / resultsPerPageAccessories : Math.floor(totalResults / resultsPerPageAccessories) + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(resultsPerPageAccessories, totalResults);
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText = totalPages;
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
                    if (totalPages === 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                    } else {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                    }
                    type = 'accessories';
                } else if (numResultsInput.closest(`.${componentName}__content-frame-alternative-products`)) {
                    resultsPerPageAlternativeProducts = parseInt(event.target.value);
                    const totalPages = totalResults % resultsPerPageAlternativeProducts === 0 ? totalResults / resultsPerPageAlternativeProducts : Math.floor(totalResults / resultsPerPageAlternativeProducts) + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(resultsPerPageAlternativeProducts, totalResults);
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-label [data-name="page-count"]`).innerText = totalPages;
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
                    if (totalPages === 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                    } else {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                    }
                    type = 'alternative-products';
                }
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value = 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).defaultValue = '1';
                this.updateProductGridPage(productGrid, 1, type);
            });
        });
    }

    async updateProductGridPage(productGrid, currentPage, type) {
        productGrid.innerHTML = '';
        const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
        if (type === 'accessories') {
            this.showGridSkeleton(`.${componentName}__content-frame-accessories`);
            scrollToAnchor(productGrid);
            const accessories = await this.getAccessories((currentPage - 1), resultsPerPageAccessories);
            this.hideGridSkeleton(`.${componentName}__content-frame-accessories`);
            accessories.list.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);
            });
        } else if (type === 'alternative-products') {
            this.showGridSkeleton(`.${componentName}__content-frame-alternative-products`);
            scrollToAnchor(productGrid);
            const alternativeProductsObject = await this.getComplemetaryProducts(((currentPage - 1) * resultsPerPageAlternativeProducts), resultsPerPageAlternativeProducts);
            const alternativeProducts = alternativeProductsObject.list;
            this.hideGridSkeleton(`.${componentName}__content-frame-alternative-products`);
            alternativeProducts.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);
            });
        }
    }

    initTooltips() {
        const tooltipContainers = document.querySelectorAll(`.${componentName}__serial-number-tooltip-container, .${componentName}__series-tooltip-container, .${componentName}__product-details-tag, .${componentName}__multiple-origin-countries-tooltip-container`);

        tooltipContainers.forEach(container => {
            const tooltip = container.querySelector(`.${componentName}__tooltip`);

            if (!tooltip) return;

            // Show tooltip on mouse enter
            container.addEventListener('mouseenter', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                    tooltip.style.maxWidth = Math.min(container.getBoundingClientRect().right - 60, 320) + 'px';
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                    tooltip.style.maxWidth = Math.min(window.innerWidth - container.getBoundingClientRect().left - 60, 320) + 'px';
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on mouse leave
            container.addEventListener('mouseleave', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
                tooltip.style.removeProperty('max-width');
            });

            // Show tooltip on focus (for accessibility)
            container.addEventListener('focus', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160)) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on blur (for accessibility)
            container.addEventListener('blur', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });
        });
    }

    insertDemoData() {
        const demoInsertData = [...document.querySelectorAll(`.${componentName}__af-demo-insert-data`)];
        let xfContentFragmentListScriptTag = null;
        let xfVideoScriptTag = null;
        demoInsertData.forEach(async (insertData) => {
            const tab = insertData.dataset.tab;
            const subtab = insertData.dataset.subtab;
            const position = insertData.dataset.position;
            const componentPath = insertData.dataset.componentPath;
            const includeCountries = insertData.dataset.includeCountries;
            const excludeCountries = insertData.dataset.excludeCountries;
            const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
            const countryCode = locale.split("-")[1];
            if (includeCountries && !includeCountries.includes(countryCode)) {
                return;
            }
            if (excludeCountries && excludeCountries.includes(countryCode)) {
                return;
            }
            try {
                const authorMode = new URLSearchParams(window.location.search).get('wcmmode') === 'disabled';
                const contentResponse = await fetch(authorMode ? `${componentPath}?wcmmode=disabled` : componentPath);
                const contentHtml = await contentResponse.text();
                const contentDocument = new DOMParser().parseFromString(contentHtml, 'text/html');
                const contentElement = contentDocument.querySelector('.container');
                let tabElements = [...document.querySelectorAll(`.${componentName}__content-frame-${tab}`)];
                if (subtab) {
                    tabElements = [...document.querySelectorAll(`.${componentName}__content-frame-${tab} .${componentName}__product-table-section-${subtab}`)];
                }
                for (const tabElement of tabElements) {
                    const contentElementClone = contentElement.cloneNode(true);
                    for (const key in registerableComponentList) {
                        const componentElements = contentElementClone.querySelectorAll(key);
                        if (componentElements.length > 0) {
                            const componentClass = registerableComponentList[key];
                            componentElements.forEach((componentElement) => {
                                try {
                                    new componentClass(componentElement).init();
                                } catch (error) {
                                    console.warn('### Error initializing component:', key, error);
                                }
                            });
                        }
                    }
                    if (position === 'top') {
                        if (tabElement.querySelector('summary')) {
                            tabElement.querySelector('summary').insertAdjacentElement('afterend', contentElementClone);
                        } else {
                            tabElement.insertAdjacentElement('afterbegin', contentElementClone);
                        }
                    } else if (position === 'bottom') {
                        tabElement.insertAdjacentElement('beforeend', contentElementClone);
                    }
                    const xfContentFragmentList = contentElementClone.querySelector('.content-fragment-list');
                    if (xfContentFragmentList && !xfContentFragmentListScriptTag) {
                        xfContentFragmentListScriptTag = document.createElement('script');
                        xfContentFragmentListScriptTag.src = '/etc.clientlibs/rockwell-automation/clientlibs/clientlib-site/resources/build/cflist.bundle.js?' + Math.random();
                        document.body.appendChild(xfContentFragmentListScriptTag);
                    }
                    const xfVideo = contentElementClone.querySelector('.video');
                    if (xfVideo && !xfVideoScriptTag) {
                        xfVideoScriptTag = document.createElement('script');
                        xfVideoScriptTag.src = '/etc.clientlibs/rockwell-automation/clientlibs/clientlib-site/resources/build/video.bundle.js?' + Math.random();
                        document.body.appendChild(xfVideoScriptTag);
                    }
                    contentElementClone.querySelectorAll('.chart script').forEach((oldScript) => {
                        const newScript = document.createElement('script');
                        const src = oldScript.getAttribute('src');

                        [...oldScript.attributes].forEach((attr) => {
                            if (attr.name !== 'src') {
                                newScript.setAttribute(attr.name, attr.value);
                            }
                        });

                        // Classic scripts created with createElement are async unless this is set first.
                        if (newScript.type !== 'module' && !oldScript.hasAttribute('async')) {
                            newScript.async = false;
                        }

                        if (oldScript.textContent) {
                            newScript.text = oldScript.textContent;
                        }
                        if (src) {
                            newScript.src = src;
                        }

                        oldScript.replaceWith(newScript);
                    });
                    if (contentElementClone.querySelector('.chart')) {
                        // wait for window.futprintChartInit to be defined then call it
                        new Promise((resolve) => {
                            const MAX_INTERVALS = 20;
                            let intervals = 0;
                            const interval = setInterval(() => {
                                if (typeof window.futprintChartInit === 'function') {
                                        clearInterval(interval);
                                        resolve();
                                    }
                                intervals++;
                                if (intervals > MAX_INTERVALS) {
                                    clearInterval(interval);
                                    resolve();
                                }
                            }, 500);
                        }).then(() => {
                            if (typeof window.futprintChartInit === 'function') {
                                window.futprintChartInit();
                            }
                        });
                    }
                }
            } catch (error) {
                console.warn('### Error inserting demo data:', componentPath, error);
            }
        });
    }

    getTranslatableProductField(productJson, field, flattenedField, defaultValue, language) {
        if (productJson[field] && productJson[field] instanceof Array) {
            try {
                for (let i = 0; i < productJson[field].length; i++) {
                    if (productJson[field][i].isocode.toLowerCase() === language.toLowerCase()) {
                        return productJson[field][i].value;
                    }
                }
            } catch (error) {
                console.warn(`Error getting translatable product field ${field} for language ${language}:`, error);
            }
            if (language.toLowerCase() !== 'en') {
                return this.getTranslatableProductField(productJson, field, flattenedField, defaultValue, 'en');
            }
        }
        return productJson[flattenedField] ? productJson[flattenedField].value : defaultValue;
    }
}

// eslint-disable-next-line consistent-return
const waitForElement = (selector) => new Promise((resolve) => {
    if (document.querySelector(selector)) {
        // eslint-disable-next-line no-promise-executor-return
        return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

async function init() {
    const product = document.querySelector(".product-new");
    if (product) {
        const productUnavailableModal = document.querySelector(`.${componentName}__unavailable-modal`);
        if (productUnavailableModal) {
            openModal(productUnavailableModal);
            waitForElement('.related-content').then((relatedContentSection) => {
                if (relatedContentSection) {
                    relatedContentSection.remove();
                }
            });
            waitForElement('.breadcrumb__nav').then((breadcrumb) => {
                if (breadcrumb) {
                    breadcrumb.remove();
                }
            });
        }
        let isEmbedded = false;
        try {
            isEmbedded = window.self !== window.top;
        } catch (e) {
            // keep the default
        }
        if (isEmbedded) {
            // Sign-in can't complete inside an iframe (the login page refuses to be framed),
            // so when the PDP is framed (e.g. the alternate-locale preview) the repair
            // documentation button opens the right-to-repair page in a new tab, in the
            // parent page's locale. Capture phase so it runs before modal-container's
            // handler on the link.
            const localePattern = /^[a-z]{2}-[a-z]{2}$/;
            let repairLocale = (new URLSearchParams(window.location.search).get('parentLocale') || '').toLowerCase();
            if (!localePattern.test(repairLocale)) {
                try {
                    repairLocale = window.top.document.documentElement.lang.toLowerCase();
                } catch (e) {
                    repairLocale = document.documentElement.lang.toLowerCase();
                }
            }
            document.addEventListener('click', (event) => {
                const link = event.target.closest && event.target.closest('a[href="#modal-repair-documentation"]');
                if (!link) return;
                event.preventDefault();
                event.stopPropagation();
                // zh-cn lives on rockwellautomation.com.cn with no locale segment in the path
                const repairUrl = new URL(`${window.location.origin}/${repairLocale}/support/product/right-to-repair.html`
                    .replace('//www.rockwellautomation.com/zh-cn/', '//www.rockwellautomation.com.cn/'));
                const catalogNumber = window.location.pathname.split('.')[1];
                if (catalogNumber) {
                    repairUrl.searchParams.set('catalogNumber', catalogNumber);
                }
                window.open(repairUrl.toString(), '_blank', 'noopener');
            }, true);
        }
        if (new URLSearchParams(window.location.search).get('previewPdpIframe') === 'true') {
            const raHeader = document.querySelector('ra-header');
            if (raHeader) {
                raHeader.remove();
            }
            const raFooter = document.querySelector('ra-footer');
            if (raFooter) {
                raFooter.remove();
            }
            waitForElement('.related-content').then((relatedContentSection) => {
                if (relatedContentSection) {
                    relatedContentSection.remove();
                }
            });
            waitForElement('.breadcrumb__nav').then((breadcrumb) => {
                if (breadcrumb) {
                    breadcrumb.remove();
                }
            });
            waitForElement('#rafb-container').then((chatbotContainer) => {
                if (chatbotContainer) {
                    chatbotContainer.remove();
                }
            });
            waitForElement('.cmp-abm-intent-drawer-container').then((abmIntentDrawer) => {
                if (abmIntentDrawer) {
                    abmIntentDrawer.remove();
                }
            });
            const piraAlertBanner = document.querySelector('.pira-alert-banner');
            if (piraAlertBanner) {
                piraAlertBanner.remove();
            } else {
                window.addEventListener('init-pira-alert-banner', () => {
                    const newPiraAlertBanner = document.querySelector('.pira-alert-banner');
                    if (newPiraAlertBanner) {
                        newPiraAlertBanner.remove();
                    }
                });
            }
            // Hide the header actions (print / share / QR / JSON), the distributor card and
            // the "Add to BOM" quick link when the PDP is rendered inside the preview iframe.
            const headerActions = document.querySelector(`.${componentName}__product-detail-header-actions`);
            if (headerActions) {
                headerActions.style.display = 'none';
            }
            // Distributor card — hide both the desktop and the tablet/mobile variants.
            document.querySelectorAll(`.${componentName}__distributor-card, .${componentName}__distributor-card-mobile`).forEach((distributorCard) => {
                distributorCard.style.display = 'none';
            });
            document.querySelectorAll(`.${componentName}__header-links-item a[href*="/my/bom"]`).forEach((bomLink) => {
                const bomItem = bomLink.closest(`.${componentName}__header-links-item`);
                (bomItem || bomLink).style.display = 'none';
            });
            // The OneTrust cookie banner is injected asynchronously, so hide its row with an
            // injected style rule so it applies whenever the banner renders in the iframe.
            // (The ABM intent drawer is prevented from loading at its source in
            // abm-intent-drawer.js, so it needs no hiding here.)
            const previewHideStyle = document.createElement('style');
            previewHideStyle.textContent = '#onetrust-banner-sdk .ot-sdk-row{display:none !important;}';
            document.head.appendChild(previewHideStyle);
            // In the preview iframe every real navigation should open in a new tab so the
            // preview itself is never replaced. Modal triggers (their href carries "#modal")
            // and other in-page anchors (href starts with "#") must stay in-page, as must
            // "javascript:" handlers. Done on click (capture) so it also covers links that
            // are rendered lazily after init.
            document.addEventListener('click', (event) => {
                const link = event.target.closest && event.target.closest('a[href]');
                if (!link) return;
                const href = link.getAttribute('href') || '';
                if (href === '' || href.startsWith('#') || href.includes('#modal') || /^javascript:/i.test(href)) {
                    return;
                }
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }, true);
            // remove previewPdpIframe query param from the url without reloading the page
            window.localStorage.setItem('previewPdpIframe', 'true');
            const url = new URL(window.location.href);
            url.searchParams.delete('previewPdpIframe');
            url.searchParams.delete('parentLocale');
            window.history.replaceState({}, '', url.toString());
        }
        const productObject = new Product();
        let sku = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.sku;
        let productName = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName;
        if (productName != undefined) {
            // Appending to Breadcrumb
            const lastBreadcrumbItem = document.querySelector('.breadcrumb__item:last-child');
            if (lastBreadcrumbItem) {
                // Clone the current last crumb and append it as the new leaf crumb.
                const clonedItem = lastBreadcrumbItem.cloneNode(true);
                lastBreadcrumbItem.insertAdjacentElement('afterend', clonedItem);

                // Scope all edits to the cloned crumb. NOTE: querying the document with
                // ".breadcrumb__link_text:last-child" / ".breadcrumb__link:last-child" is
                // wrong here — every link_text is the last child of its own <a> (so the
                // document query returns the FIRST crumb, not the clone), and the <a> is
                // never the last child of its <li> (a chevron <span> and <meta> follow it,
                // so that query matches nothing).
                const clonedText = clonedItem.querySelector('.breadcrumb__link_text');
                if (clonedText) {
                    clonedText.textContent = sku;
                }

                // The catalog number is the current page, so unwrap the anchor but
                // KEEP the inner ".breadcrumb__link_text" span — that span carries the
                // breadcrumb text styling (font + padding). Replacing the anchor with a
                // bare text node (as before) dropped that span and left the catalog
                // number looking different from the other crumbs. This mirrors the
                // server markup for the active crumb (data-sly-unwrap on the <a>).
                const clonedLink = clonedItem.querySelector('.breadcrumb__link');
                if (clonedLink) {
                    clonedLink.outerHTML = clonedLink.innerHTML;
                }
                // Flag the appended crumb as the active/current item for parity with
                // the server-rendered breadcrumb.
                clonedItem.classList.add('breadcrumb__item--active');

                // Keep the schema.org position ordinal correct for the appended crumb.
                const clonedPosition = clonedItem.querySelector('meta[itemprop="position"]');
                if (clonedPosition) {
                    const prevPosition = parseInt(
                        lastBreadcrumbItem.querySelector('meta[itemprop="position"]')?.getAttribute('content'),
                        10
                    );
                    if (!Number.isNaN(prevPosition)) {
                        clonedPosition.setAttribute('content', String(prevPosition + 1));
                    }
                }
            }

            const emailPageElement = document.querySelector(`${componentName}__email-page`);
            if (emailPageElement) {
                emailPageElement.addEventListener('click', () => {
                    let uri = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
                    let catalogNumber = 'Catalog #: ' + sku;
                    let brand = 'Rockwell Automation';
                    let body = productName + ' from ' + brand + '\n' + catalogNumber + '\n' + uri + '\n';
                    window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + productName) + '&body=' + encodeURIComponent(body);
                });
            }

            let locale = document.querySelector(".search__configuration")?.getAttribute("data-search-locale") || 'en-US';
            let searchEndpoint = document.querySelector(".search__configuration")?.getAttribute('data-search-base-url') || 'https://www.rockwellautomation.com/search';
            let endpoint = `${searchEndpoint}/ra-${locale};keyword=${sku};activeTab=Literature;`;
            const literatureResult = document.querySelector('#literature-result');
            if (literatureResult) {
                literatureResult.setAttribute("href", endpoint);
            }

            let serialNumber = '';
            if (new URLSearchParams(window.location.search).get('SN')) {
                serialNumber = new URLSearchParams(window.location.search).get('SN').split(' ')[0];
            } else if (window.location.hash.startsWith('#SN=')) {
                serialNumber = window.location.hash.substring(4).split(' ')[0];
            }
            const serialNumberHeaderTag = document.querySelectorAll(`.${componentName}__serial-number`);
            const jsonDownloadButton = document.querySelector(`.${componentName}__json-download-button`);
            const registerProductLink = document.querySelector(`.${componentName}__register-product-link`);

            if (serialNumber) {
                if (serialNumberHeaderTag.length > 0) {
                    serialNumberHeaderTag.forEach(el => {
                        const textEl = el.querySelector(`.${componentName}__serial-number-text`);
                        if (textEl) {
                            textEl.textContent = textEl.textContent + ' ' + serialNumber;
                        }
                    });
                }
                if (jsonDownloadButton) {
                    jsonDownloadButton.href = jsonDownloadButton.href + '&serialNumber=' + serialNumber;
                    jsonDownloadButton.classList.remove('hidden');
                }
                if (registerProductLink) {
                    registerProductLink.href = registerProductLink.href + '&SN=' + serialNumber;
                }
            } else {
                serialNumberHeaderTag?.forEach(el => el.remove());
            }
            const serialNumberTooltipText = document.querySelectorAll(`.${componentName}__serial-number .${componentName}__tooltip-text`);
            if (serialNumberTooltipText) {
                serialNumberTooltipText.forEach(el => {
                    const serialNumberTooltipLink = el.querySelector(`.${componentName}__serial-number-tooltip-link`);
                    const serialNumberTooltipLinkHtml = serialNumberTooltipLink.outerHTML;
                    serialNumberTooltipLink.remove();
                    el.innerHTML = el.innerHTML.replace('{}', serialNumberTooltipLinkHtml);
                });
            }

            const dppQueryParam = new URLSearchParams(window.location.search).get('dpp');
            if (jsonDownloadButton && dppQueryParam === 'true') {
                jsonDownloadButton.classList.remove('hidden');
            }

            const seriesSelect = document.querySelector(`.${componentName}__select[name="sustainabilitySeriesSelect"]`);
            const seriesSelectInput = document.querySelector(`.${componentName}__select-input[name="sustainabilitySeriesSelect"]`);
            const loadingSkeletons = document.querySelectorAll(`.${componentName}__loading-skeleton`);
            let defaultSeries = null;
            if (seriesSelect && serialNumber) {
                // get default series for the serial number
                try {
                    const response = await fetch(`${productDetailServletEndpoint}?serialNumber=${serialNumber}&catalogNumber=${sku}&getDefaultSeries=true`);
                    const data = await response.json();
                    if (data.list_of_series && data.list_of_series.length > 0) {
                        defaultSeries = data.list_of_series[0];
                        if (defaultSeries) {
                            seriesSelect.querySelector(`li[data-value="${defaultSeries}"]`).click();
                            seriesSelect.parentElement.classList.add('disabled');
                        }
                    }
                } catch (error) {
                    console.warn('### Error getting default series for the serial number:', error);
                }
            }
            if (!defaultSeries && seriesSelectInput) {
                defaultSeries = seriesSelectInput.dataset.defaultSeries;
                if (defaultSeries) {
                    seriesSelect.querySelector(`li[data-value="${defaultSeries}"]`).click();
                }
            }
            [...loadingSkeletons].forEach((loadingSkeleton) => {
                loadingSkeleton.remove();
            });
            const sidebarMenu = document.querySelector(`.${componentName}__sidebar`);
            if (sidebarMenu) {
                sidebarMenu.classList.remove('hidden');
            }
            const contentDesktop = document.querySelector(`.${componentName}__content-desktop`);
            if (contentDesktop) {
                contentDesktop.classList.remove('hidden');
            }
            const contentMobile = document.querySelector(`.${componentName}__content-mobile`);
            if (contentMobile) {
                contentMobile.classList.remove('hidden');
            }
            const sustainabilityControlContainer = document.querySelector(`.${componentName}__sustainability-control-container`);
            if (sustainabilityControlContainer) {
                sustainabilityControlContainer.classList.remove('hidden');
            }

            const tableSectionContainers = document.querySelectorAll(`.${componentName}__product-table-section-container`);
            Array.from(tableSectionContainers).forEach((container) => {
                const sectionSelect = container.querySelector(`.${componentName}__select-container`);
                const multiColumnSections = container.querySelector(`.${componentName}__product-table-sections--multi-column`);
                if (sectionSelect && multiColumnSections) {
                    if (multiColumnSections.firstElementChild.classList.contains(`${componentName}__product-table-section--two-column`)) {
                        multiColumnSections.firstElementChild.insertAdjacentElement('afterend', sectionSelect);
                    }
                }
            });

            const hasAiTranslations = document.querySelector(`.${componentName}__product-detail-header`)?.dataset.hasAiTranslations;
            if (hasAiTranslations) {
                const aiTranslationsDisclaimer = document.querySelector('.ai-translations-disclaimer-text');
                if (aiTranslationsDisclaimer) {
                    aiTranslationsDisclaimer.classList.remove('hidden');
                }
            }

            initInquiryForm();
            productObject.readHash();
            productObject.filterDownloadsTable('series');
        }
    }
}

window.piraInitPdp = init;

let signInEventListenerAdded = false;
let alreadySignedIn = false;
let technicalSpecsLoaded = false;

// Add a small delay, sometimes pages load fast.
const SPEC_SKELETON_DELAY = 150;

function loadFullTechnicalSpecs() {
    const hiddenFieldsIndicator = document.querySelector(`.${componentName}__hidden-fields-indicator`);
    if (!hiddenFieldsIndicator || technicalSpecsLoaded) {
        return;
    }

    technicalSpecsLoaded = true;
    const sku = hiddenFieldsIndicator.dataset.sku;

    // Get the current page path without query params and hash
    const currentPath = window.location.pathname;
    // Extract SKU from path like: /content/.../details.20BD5P0A0AYNAED0.html
    // Convert to: /content/.../details/jcr:content/root/main-par/product.fullspecs.20BD5P0A0AYNAED0.html
    const pathWithoutSku = currentPath.replace(/\.[^\/]+\.html$/, '');
    const contentPath = pathWithoutSku + '/jcr:content/root/main-par/product.fullspecs.' + sku + '.html';

    console.log(`### Loading full technical specifications from: ${contentPath}`);

    // Skeleton only for the tab on screen.
    const rawHashTab = window.location.hash.replace('#', '').split('_')[0];
    const hashTab = /^[a-zA-Z0-9-]+$/.test(rawHashTab) ? rawHashTab : '';
    const firstTab = document.querySelector(`.${componentName}__sidebar-item:not(.${componentName}__subcategory-item)`)?.dataset.selector;
    const currentTab = (hashTab && document.querySelector(`.${componentName}__content-frame-${hashTab}`)) ? hashTab : firstTab;

    // Skeleton the tab only if there is a login prompt, and a skeleton to show in place of the rows.
    const loadingClass = `${componentName}__product-table--loading`;
    const specTables = currentTab
        ? Array.from(document.querySelectorAll(`.${componentName}__content-frame-${currentTab} #${componentName}-spec-table`))
            .filter((table) => table.querySelector(`.${componentName}__spec-skeleton`)
                && table.closest(`.${componentName}__content-frame`)?.querySelector(`.${componentName}__spec-login-prompt`))
        : [];
    const setLoading = (on) => specTables.forEach((table) => table.classList.toggle(loadingClass, on));

    const loginPrompts = document.querySelectorAll(`.${componentName}__spec-login-prompt`);
    // Restore on failure only what was on screen; test display, not 'active' — checkSignIn already stripped it.
    const visiblePrompts = Array.from(loginPrompts).filter((prompt) => getComputedStyle(prompt).display !== 'none');

    // Hide the prompts up front rather than after the response lands, so the box does not sit
    // there through the whole request and then vanish as the rows appear.
    Array.from(loginPrompts).forEach((prompt) => {
        prompt.style.display = 'none';
        prompt.classList.remove('active');
    });
    const skeletonTimer = setTimeout(() => setLoading(true), SPEC_SKELETON_DELAY);

    // Make AJAX request to load full specifications
    fetch(contentPath)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            clearTimeout(skeletonTimer);
            console.log('### Successfully loaded full technical specifications');
            // Create a temporary container to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // The fullspecs selector should only return the spec table, not the dropdowns
            // Find the spec table from the AJAX response
            const newSpecTable = tempDiv.querySelector(`#${componentName}-spec-table`);

            // Replace only the spec table content
            if (newSpecTable) {
                // Match the tab it belongs to; the first spec table on the page is the overview one.
                const tabTable = `.${componentName}__content-frame-${newSpecTable.dataset.category} #${componentName}-spec-table`;

                // The fetched markup marks the first section active; keep the one on screen instead.
                const replaceTable = (table) => {
                    const activeSection = table.querySelector(`.${componentName}__product-table-section-container.active`)?.dataset.className;
                    table.innerHTML = newSpecTable.innerHTML;
                    const containers = Array.from(table.querySelectorAll(`.${componentName}__product-table-section-container`));
                    if (activeSection && containers.some((container) => container.dataset.className === activeSection)) {
                        containers.forEach((container) => {
                            container.classList.toggle('active', container.dataset.className === activeSection);
                        });
                    }
                };

                // Replace in desktop view
                const existingDesktopTable = document.querySelector(`.${componentName}__content-desktop ${tabTable}`);
                if (existingDesktopTable) {
                    console.log('### Replacing desktop spec table with full specifications');
                    replaceTable(existingDesktopTable);
                }

                // Replace in mobile view - mobile also uses the same ID
                const existingMobileTable = document.querySelector(`.${componentName}__content-mobile ${tabTable}`);
                if (existingMobileTable) {
                    console.log('### Replacing mobile spec table with full specifications');
                    replaceTable(existingMobileTable);
                }
            }
            setLoading(false);

            // No need to re-initialize selects since we're not touching the dropdowns
        })
        .catch(error => {
            clearTimeout(skeletonTimer);
            console.error('### Failed to load full technical specifications:', error);
            // The rows were only hidden, so clearing the modifier is the whole rollback.
            setLoading(false);
            visiblePrompts.forEach((prompt) => {
                prompt.style.display = 'flex';
                prompt.classList.add('active');
            });
        });
}

function checkSignIn() {
    let isSignedIn = false;
    try {
        isSignedIn = !!(window['userData'] || JSON.parse(localStorage.getItem('loggedInData')));
    } catch (e) { }

    console.log(`### User signed in status: ${isSignedIn ? 'SIGNED IN' : 'NOT SIGNED IN'}`);

    const iframeElements = document.querySelectorAll(`.${componentName}__drawings-iframe`);
    const iframePlaceholders = document.querySelectorAll(`.${componentName}__drawings-iframe-placeholder`);
    const specLoginPrompts = document.querySelectorAll(`.${componentName}__spec-login-prompt`);
    const hiddenFieldsIndicator = document.querySelector(`.${componentName}__hidden-fields-indicator`);
    const jsonDownloadButton = document.querySelector(`.${componentName}__json-download-button`);

    if (isSignedIn) {
        if (jsonDownloadButton) {
            jsonDownloadButton.classList.remove('hidden');
        }
        if (alreadySignedIn) {
            return;
        }
        alreadySignedIn = true;
        try {
            window.removeEventListener('message', checkSignIn);
        } catch (e) { }

        // Handle drawings iframe
        if (iframeElements.length > 0) {
            Array.from(iframeElements).forEach((iframeElement) => {
                const src = iframeElement.getAttribute('src');
                const dataSrc = iframeElement.dataset.src;
                if (!src && dataSrc) {
                    iframeElement.setAttribute('src', dataSrc);
                }
                iframeElement.classList.add('active');
                const iframeMsgs = document.querySelectorAll(`.${componentName}__drawings-iframe-text`);
                iframeMsgs.forEach((msg) => msg.classList.add('active'));
            });
        }

        Array.from(iframePlaceholders).forEach((iframePlaceholder) => {
            iframePlaceholder.classList.remove('active');
        });

        // Handle technical specifications
        if (hiddenFieldsIndicator && hiddenFieldsIndicator.dataset.hasHiddenFields === 'true') {
            console.log('### Hidden fields detected, loading full technical specifications via AJAX');
            // Load full technical specifications via AJAX
            loadFullTechnicalSpecs();
        }
    } else {
        if (!signInEventListenerAdded) {
            signInEventListenerAdded = true;
            window.addEventListener('message', checkSignIn);
        }

        // Handle drawings placeholders
        Array.from(iframePlaceholders).forEach((iframePlaceholder) => {
            iframePlaceholder.classList.add('active');
        });

        if (iframeElements.length > 0) {
            Array.from(iframeElements).forEach((iframeElement) => {
                iframeElement.classList.remove('active');
            });
        }

        // Show technical specifications login prompts (using same styling as drawings)
        if (hiddenFieldsIndicator && hiddenFieldsIndicator.dataset.hasHiddenFields === 'true') {
            console.log('### Hidden fields detected, showing login prompt for technical specifications');
            Array.from(specLoginPrompts).forEach((prompt) => {
                prompt.style.display = 'flex'; // Use flex like drawings placeholder
                prompt.classList.add('active'); // Add active class like drawings
            });
        }
    }
}

function initInquiryForm() {
    const inquiryForm = document.querySelector(`.${componentName}__inquiry-form`);
    if (inquiryForm) {
        const theme = document.querySelector(`.${componentName}__product-detail-header`)?.dataset.theme;
        const catalogNumberInput = inquiryForm.querySelector(`.${theme}-input__input[name="$CatalogNumber"]`);
        if (catalogNumberInput && catalogNumberInput.value) {
            catalogNumberInput.disabled = true;
            catalogNumberInput.classList.add(`${theme}-input__input--disabled`);
        }

        const serialNumberInput = inquiryForm.querySelector(`.${theme}-input__input[name="$SerialNumber"]`);
        if (serialNumberInput) {
            let serialNumber = '';
            if (new URLSearchParams(window.location.search).get('SN')) {
                serialNumber = new URLSearchParams(window.location.search).get('SN').split(' ')[0];
            } else if (window.location.hash.startsWith('#SN=')) {
                serialNumber = window.location.hash.substring(4).split(' ')[0];
            }
            if (serialNumber) {
                serialNumberInput.value = serialNumber;
            }
        }


        let loggedInData;
        if (window['userData']) {
            loggedInData = window['userData'];
        } else if (localStorage.getItem('loggedInData')) {
            try {
                loggedInData = JSON.parse(localStorage.getItem('loggedInData'));
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            const emailInput = inquiryForm.querySelector(`.${theme}-input__input[name="$EmailAddress"]`);
            if (emailInput) {
                emailInput.value = loggedInData.email;
            }
            const companyInput = inquiryForm.querySelector(`.${theme}-input__input[name="$Company"]`);
            if (companyInput) {
                companyInput.value = loggedInData.company;
            }
            const firstNameInput = inquiryForm.querySelector(`.${theme}-input__input[name="$FirstName"]`);
            if (firstNameInput) {
                firstNameInput.value = loggedInData.firstName;
            }
            const lastNameInput = inquiryForm.querySelector(`.${theme}-input__input[name="$LastName"]`);
            if (lastNameInput) {
                lastNameInput.value = loggedInData.lastName;
            }
        }

        [...inquiryForm.querySelectorAll('input[data-required], textarea[data-required], select[data-required]')].forEach((field) => {
            field.addEventListener('blur', () => {
                console.log('### Field blurred:', field);
                const parentContainer = field.closest(`.${theme}-formfield`);
                const isText = field.classList.contains(`${theme}-input__input`);
                const isCheckbox = field.classList.contains(`${theme}-checkbox__checkbox`);
                const isSelect = field.tagName.toLowerCase() === 'select' || field.classList.contains(`${theme}-select__select`);
                if (isText) {
                    if (field.value) {
                        field.classList.remove(`${theme}-input__input--invalid`);
                        parentContainer.classList.remove(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'true');
                        }
                    } else {
                        field.classList.add(`${theme}-input__input--invalid`);
                        parentContainer.classList.add(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else if (isCheckbox) {
                    if (field.checked) {
                        field.classList.remove(`${theme}-checkbox__checkbox--invalid`);
                        parentContainer.classList.remove(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'true');
                        }
                    } else {
                        field.classList.add(`${theme}-checkbox__checkbox--invalid`);
                        parentContainer.classList.add(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else if (isSelect) {
                    if (field.value) {
                        field.classList.remove(`${theme}-select__select--invalid`);
                        parentContainer.classList.remove(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'true');
                        }
                    } else {
                        field.classList.add(`${theme}-select__select--invalid`);
                        parentContainer.classList.add(`${theme}-formfield--invalid`);
                        const errorMessage = parentContainer.querySelector(`.${theme}-formfield__caption-error`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                }


                const submitButton = inquiryForm.querySelector(`.${componentName}__inquiry-form-submit-button`);
                submitButton.disabled = handleValidation(inquiryForm, false);
            });
        });

        inquiryForm.addEventListener('submit', async (event) => {
            try {
                event.preventDefault();

                const hasError = handleValidation(inquiryForm, true);
                if (hasError) {
                    focusFirstInvalidField(inquiryForm);
                    return;
                }

                const submitButton = inquiryForm.querySelector(`.${componentName}__inquiry-form-submit-button`);
                submitButton.disabled = true;
                submitButton.querySelector(`.${componentName}__inquiry-form-submit-label`).classList.add('hidden');
                submitButton.querySelector(`.${componentName}__inquiry-form-submit-label--loading`).classList.remove('hidden');

                const formData = new FormData(inquiryForm);
                formData.append('$CatalogNumber', catalogNumberInput.value);
                const response = await fetch('/bin/rockwell-automation/environmental-compliance-inquiry', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                console.log('### Inquiry form response:', data);
                if (response.ok) {
                    const inquiryFormContainer = document.querySelector(`.${componentName}__inquiry-form-container`);
                    if (inquiryFormContainer) {
                        inquiryFormContainer.classList.add('hidden');
                    }
                    const successMessage = document.querySelector(`.${componentName}__inquiry-form-success-message-container`);
                    if (successMessage) {
                        successMessage.classList.remove('hidden');
                    }
                } else {
                    const inquiryFormContainer = document.querySelector(`.${componentName}__inquiry-form-container`);
                    if (inquiryFormContainer) {
                        inquiryFormContainer.classList.add('hidden');
                    }
                    const errorMessage = document.querySelector(`.${componentName}__inquiry-form-error-message-container`);
                    if (errorMessage) {
                        errorMessage.classList.remove('hidden');
                    }
                }
            } catch (error) {
                console.warn('Failed to submit inquiry:', error);
                const inquiryFormContainer = document.querySelector(`.${componentName}__inquiry-form-container`);
                if (inquiryFormContainer) {
                    inquiryFormContainer.classList.add('hidden');
                }
                const errorMessage = document.querySelector(`.${componentName}__inquiry-form-error-message-container`);
                if (errorMessage) {
                    errorMessage.classList.remove('hidden');
                }
            }
        });
    }
}

function handleValidation(form, showErrorState = true) {
    const theme = document.querySelector(`.${componentName}__product-detail-header`)?.dataset.theme;
    let hasError = false;
    const requiredFields = form.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

    [...requiredFields].forEach((fieldEle) => {
        if (fieldEle.disabled || fieldEle.closest(`.${theme}-formfield`).classList.contains('hidden')) {
            return;
        }
        const isText = fieldEle.classList.contains(`${theme}-input__input`);
        const isCheckbox = fieldEle.classList.contains(`${theme}-checkbox__checkbox`);
        const isSelect = fieldEle.tagName.toLowerCase() === 'select' || fieldEle.classList.contains(`${theme}-select__select`);

        // Text Fields
        if (isText) {
            const inputValue = fieldEle.value;
            const isEmpty = inputValue === '';
            const parentContainerEle = fieldEle.closest(`.${theme}-formfield`);
            const errorMessage = parentContainerEle.querySelector(`.${theme}-formfield__caption-error`);

            if (isEmpty) {
                hasError = true;
                if (showErrorState) {
                    parentContainerEle.classList.add(`${theme}-formfield--invalid`);
                    fieldEle.classList.add(`${theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                }
            } else {
                parentContainerEle.classList.remove(`${theme}-formfield--invalid`);
                fieldEle.classList.remove(`${theme}-input__input--invalid`);
                if (errorMessage) {
                    errorMessage.setAttribute('aria-hidden', 'true');
                }
            }
        }

        // Checkboxes
        if (isCheckbox) {
            const parentContainerEle = fieldEle.closest(`.${theme}-formfield`);
            const errorMessage = parentContainerEle.querySelector(`.${theme}-formfield__caption-error`);
            const isEmpty = !fieldEle.checked;

            if (isEmpty) {
                hasError = true;
                if (showErrorState) {
                    parentContainerEle.classList.add(`${theme}-formfield--invalid`);
                    fieldEle.classList.add(`${theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                }
            } else {
                parentContainerEle.classList.remove(`${theme}-formfield--invalid`);
                fieldEle.classList.remove(`${theme}-checkbox__checkbox--invalid`);
                if (errorMessage) {
                    errorMessage.setAttribute('aria-hidden', 'true');
                }
            }
        }

        // Selects
        if (isSelect) {
            const isEmpty = fieldEle.value === '';
            const parentContainerEle = fieldEle.closest(`.${theme}-formfield`);
            const errorMessage = parentContainerEle.querySelector(`.${theme}-formfield__caption-error`);

            if (isEmpty) {
                hasError = true;
                if (showErrorState) {
                    parentContainerEle.classList.add(`${theme}-formfield--invalid`);
                    fieldEle.classList.add(`${theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                }
            } else {
                parentContainerEle.classList.remove(`${theme}-formfield--invalid`);
                fieldEle.classList.remove(`${theme}-select__select--invalid`);
                if (errorMessage) {
                    errorMessage.setAttribute('aria-hidden', 'true');
                }
            }
        }
    });

    return hasError;
}

function focusFirstInvalidField(form) {
    const theme = document.querySelector(`.${componentName}__product-detail-header`)?.dataset.theme;
    const requiredFields = form.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

    Array.from(requiredFields).some((field) => {
        const formfield = field.closest(`.${theme}-formfield`);

        // Skip hidden fields
        if (field.disabled || formfield.classList.contains('hidden')) {
            return false;
        }

        // Check if field has invalid state
        if (formfield.classList.contains(`${theme}-formfield--invalid`)) {
            field.focus();
            return true; // breaks out of some()
        }
        return false;
    });
}

/**
 * Reads a cookie value by name. Returns null if not present.
 */
function getCookieValue(name) {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '\\s*=\\s*([^;]+)'));
    return match ? match[1] : null;
}

/**
 * On a PDP, redirect the visitor to the product in their preferred (langSite
 * cookie) locale when that differs from the current page locale:
 *   - preferred-locale PDP exists                     -> go to that product page
 *   - preferred PDP is a 404 and current PDP is a 404 -> go to preferred hardware page
 *   - preferred PDP is a 404 and current PDP is valid -> stay on the current product page
 * Does nothing if there is no cookie or the locales already match.
 */
function redirectPdpByCookie() {
    const path = window.location.pathname;

    // Only act on PDP detail URLs: /<locale>/products/details.<catalog>.html
    if (!/\/products\/details\.[^/]+\.html$/.test(path)) {
        return;
    }

    // Preferred locale from the langSite cookie, e.g. "/pt-br.html" -> "pt-br".
    const langSite = getCookieValue('langSite');
    if (!langSite) {
        return;
    }
    const preferredLocale = decodeURIComponent(langSite).replace(/^\/(.+)\.html$/, '$1').toLowerCase();
    if (!preferredLocale) {
        return;
    }

    // Current locale from the first path segment, e.g. "en-us".
    const localeMatch = path.match(/^\/([a-z]{2}-[a-z]{2,3})\//i);
    const currentLocale = localeMatch ? localeMatch[1].toLowerCase() : '';

    // Only redirect when the cookie locale differs from the current page locale.
    if (!currentLocale || currentLocale === preferredLocale) {
        return;
    }

    // Whether the current PDP actually rendered a product (vs. a 404/not-found).
    const currentPdpExists = Boolean(document.querySelector(`.${componentName}__product-detail-header`));

    let targetPdpUrl = window.location.origin
        + path.replace(/^\/[a-z]{2}-[a-z]{2,3}\//i, `/${preferredLocale}/`)
        + window.location.search;

    // zh-cn is served from the .com.cn domain without a locale prefix, so
    // swapping in "/zh-cn" collapses to ".com.cn" (matches HrefLang externalize).
    if (preferredLocale === 'zh-cn') {
        targetPdpUrl = targetPdpUrl.replace('.com/zh-cn', '.com.cn');
    }

    // Fetch the preferred-locale PDP and check whether it actually rendered a
    // product (its server-rendered product header is present). A "not available"
    // product can still respond 200 with a no-data page, or render a styled 404,
    // so the HTTP status alone is not reliable -- inspect the markup instead.
    fetch(targetPdpUrl, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const preferredHasProduct = Boolean(doc.querySelector(`.${componentName}__product-detail-header`));
            if (preferredHasProduct) {
                // Product exists in the preferred locale -> go there.
                window.location.href = targetPdpUrl;
            }
            // Otherwise the current PDP is valid -> stay on it.
        });
}

function main() {
    redirectPdpByCookie();
    init();
    checkSignIn();
    const hash = window.location.hash;
    if (hash && hash.startsWith("#sustainability_")) {
        const targetElement = document.getElementById('sustainability-subcategory-items');
        const targetTab = document.querySelector(`.${componentName}__sidebar-item[data-selector="${hash.substring(1)}"]`);
        if (targetElement && targetTab) {
            targetElement.classList.remove("ra-product-new__subcategory-items-collapse");
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
} else {
    main();
}